import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardActions,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Chip,
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Badge,
  Divider,
  Paper,
  Snackbar,
  Alert,
  InputAdornment,
  Tooltip,
  CircularProgress
} from '@mui/material';
import {
  ThumbUp,
  Comment,
  Share,
  Group,
  Add,
  Notifications,
  Public,
  Lock,
  People,
  Send,
  Favorite,
  FavoriteBorder,
  AddPhotoAlternate,
  Edit,
  Delete,
  CheckCircle,
  Cancel,
  Close,
  PersonAdd,
  CheckCircleOutline,
  Person,
  HourglassEmpty,
  Check
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { apiUrl } from '../coreservices/environment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    paddingTop: theme.spacing(4),
  },
  header: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  communityCard: {
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  createButton: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    color: 'white',
    fontWeight: 'bold',
    padding: '12px 30px',
    borderRadius: '25px',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  tabPanel: {
    padding: theme.spacing(3, 0),
  },
  postCard: {
    marginBottom: theme.spacing(3),
    borderRadius: '12px',
    overflow: 'hidden',
  },
  postHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderBottom: '1px solid #e0e0e0',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: theme.spacing(1, 2),
  },
  commentSection: {
    padding: theme.spacing(2),
    backgroundColor: '#fafafa',
  },
  notificationItem: {
    borderLeft: '4px solid #667eea',
    marginBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  imagePreview: {
    maxWidth: '100%',
    maxHeight: '400px',
    borderRadius: '8px',
    marginTop: theme.spacing(2),
    objectFit: 'contain',
  },
  fileInput: {
    display: 'none',
  },
  clickableCount: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },
  },
  joinedButton: {
    backgroundColor: '#4caf50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },
  pendingButton: {
    backgroundColor: '#ff9800',
    color: 'white',
    '&:hover': {
      backgroundColor: '#f57c00',
    },
  },
}));

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`community-tabpanel-${index}`}
      aria-labelledby={`community-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const Community = () => {
  const classes = useStyles();
  const history = useHistory();
  const [tabValue, setTabValue] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [communityPosts, setCommunityPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Get current user data from localStorage
  const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
  const currentUserId = userData?.userId;
  const currentUserName = userData?.firstName || 'User';

  const [newCommunity, setNewCommunity] = useState({
    communityName: '',
    description: '',
    type: 'public',
    category: '',
    userId: currentUserId,
    createdBy: currentUserName,
    profilePicture: null
  });

  const [newPost, setNewPost] = useState({
    content: '',
    imageFile: null,
    imagePreview: null
  });
  const [comment, setComment] = useState('');
  const [postComments, setPostComments] = useState({});

  // State for dynamic data from API
  const [communities, setCommunities] = useState([]);
  const [myCommunities, setMyCommunities] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [memberRequests, setMemberRequests] = useState([]);
  const [userLikes, setUserLikes] = useState({});
  const [isMember, setIsMember] = useState(false);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [communityStatus, setCommunityStatus] = useState({});
  const [membersDialogOpen, setMembersDialogOpen] = useState(false);
  const [likesDialogOpen, setLikesDialogOpen] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedLikes, setSelectedLikes] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [loadingLikes, setLoadingLikes] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState({});


  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editCommunityData, setEditCommunityData] = useState({
    communityId: null,
    communityName: '',
    description: '',
    category: '',
    type: 'public',
    profilePicture: null
  });
  const [editProfilePreview, setEditProfilePreview] = useState(null);
  const [editing, setEditing] = useState(false);

  // Fetch community status for a specific community
  // const fetchCommunityStatus = async (communityId) => {
  //   if (!currentUserId) return;

  //   setCheckingStatus(prev => ({ ...prev, [communityId]: true }));
  //   try {
  //     const response = await fetch(`${apiUrl}/communitymaster/status/${communityId}/${currentUserId}`);
  //     if (response.ok) {
  //       const status = await response.json();
  //       setCommunityStatus(prev => ({ ...prev, [communityId]: status }));
  //     }
  //   } catch (error) {
  //     console.error('Error fetching community status:', error);
  //   } finally {
  //     setCheckingStatus(prev => ({ ...prev, [communityId]: false }));
  //   }
  // };

  const fetchCommunityStatus = async (communityId) => {
    if (!currentUserId) return;

    setCheckingStatus(prev => ({ ...prev, [communityId]: true }));
    try {
      const response = await fetch(`${apiUrl}/communitymaster/status/${communityId}/${currentUserId}`);
      if (response.ok) {
        // Try to parse as JSON first, if fails, treat as plain text
        const text = await response.text();
        let status;
        try {
          // Try to parse as JSON
          const data = JSON.parse(text);
          status = data.status || data; // Handle both {status: "..."} and plain string
        } catch (e) {
          // If not valid JSON, use the text directly
          status = text.replace(/"/g, ''); // Remove quotes if present
        }
        setCommunityStatus(prev => ({ ...prev, [communityId]: status }));
      }
    } catch (error) {
      console.error('Error fetching community status:', error);
      // Fallback to default status
      setCommunityStatus(prev => ({ ...prev, [communityId]: 'not_joined' }));
    } finally {
      setCheckingStatus(prev => ({ ...prev, [communityId]: false }));
    }
  };

  // Fetch status for all communities
  const fetchAllCommunityStatus = async () => {
    if (!currentUserId || communities.length === 0) return;

    communities.forEach(community => {
      fetchCommunityStatus(community.communityId);
    });
  };

  // Fetch all approved communities
  const fetchAllCommunities = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/communitymaster`);
      if (response.ok) {
        const data = await response.json();
        setCommunities(data);

        // Fetch community status for each community
        if (currentUserId) {
          setTimeout(() => {
            fetchAllCommunityStatus();
          }, 100);
        }
      } else {
        throw new Error('Failed to fetch communities');
      }
    } catch (error) {
      console.error('Error fetching communities:', error);
      showSnackbar('Error fetching communities', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Fetch my approved communities
  // const fetchMyCommunities = async () => {
  //   if (!currentUserId) return;

  //   try {
  //     const response = await fetch(`${apiUrl}/communitymaster/mycommunities/${currentUserId}`);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setMyCommunities(data);
  //     } else {
  //       throw new Error('Failed to fetch my communities');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching my communities:', error);
  //     showSnackbar('Error fetching your communities', 'error');
  //   }
  // };

  // Fetch my approved communities
  const fetchMyCommunities = async () => {
    if (!currentUserId) return;

    try {
      // Fetch all communities created by user (including pending/rejected)
      const response = await fetch(`${apiUrl}/communitymaster/admin/all`);
      if (response.ok) {
        const allCommunities = await response.json();
        // Filter communities created by current user
        const myCommunitiesList = allCommunities.filter(community =>
          community.userId === currentUserId
        );
        setMyCommunities(myCommunitiesList);
      } else {
        throw new Error('Failed to fetch my communities');
      }
    } catch (error) {
      console.error('Error fetching my communities:', error);
      showSnackbar('Error fetching your communities', 'error');
    }
  };

  // Fetch notifications (filter out inactive)
  const fetchNotifications = async () => {
    if (!currentUserId) return;

    try {
      const response = await fetch(`${apiUrl}/communitymaster/notifications/${currentUserId}`);
      if (response.ok) {
        const data = await response.json();
        setNotifications(data.filter(notification => notification.isActive));
      } else {
        throw new Error('Failed to fetch notifications');
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  // Fetch community posts
  const fetchCommunityPosts = async (communityId) => {
    try {
      const response = await fetch(`${apiUrl}/communitymaster/posts/${communityId}`);
      if (response.ok) {
        const data = await response.json();
        setCommunityPosts(data);

        // Check likes for each post
        data.forEach(post => {
          checkUserLike(post.postId);
        });
      } else {
        throw new Error('Failed to fetch posts');
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
    }
  };

  // Fetch member requests for my communities
  const fetchMemberRequests = async () => {
    if (!currentUserId) return;

    try {
      const requests = [];
      for (const community of myCommunities) {
        const response = await fetch(`${apiUrl}/communitymaster/member/requests/${community.communityId}`);
        if (response.ok) {
          const data = await response.json();
          requests.push(...data.map(req => ({ ...req, communityName: community.communityName })));
        }
      }
      setMemberRequests(requests);
    } catch (error) {
      console.error('Error fetching member requests:', error);
    }
  };

  // Check if user has liked a post
  const checkUserLike = async (postId) => {
    if (!currentUserId) return;

    try {
      const response = await fetch(`${apiUrl}/communitymaster/like/check/${postId}/${currentUserId}`);
      if (response.ok) {
        const hasLiked = await response.json();
        setUserLikes(prev => ({ ...prev, [postId]: hasLiked }));
      }
    } catch (error) {
      console.error('Error checking like:', error);
    }
  };

  // Check if user is member of community
  const checkMembership = async (communityId) => {
    if (!currentUserId || !communityId) return;

    try {
      const response = await fetch(`${apiUrl}/communitymaster/member/check/${communityId}/${currentUserId}`);
      if (response.ok) {
        const isMember = await response.json();
        setIsMember(isMember);

        // Also update community status
        fetchCommunityStatus(communityId);
      }
    } catch (error) {
      console.error('Error checking membership:', error);
    }
  };

  // Create new community with profile picture
  const handleCreateCommunity = async () => {
    if (!newCommunity.communityName.trim() || !newCommunity.description.trim() || !newCommunity.category.trim()) {
      showSnackbar('Please fill all required fields', 'error');
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('communityName', newCommunity.communityName);
      formData.append('description', newCommunity.description);
      formData.append('category', newCommunity.category);
      formData.append('type', newCommunity.type);
      formData.append('userId', newCommunity.userId);
      formData.append('createdBy', newCommunity.createdBy);

      if (newCommunity.profilePicture instanceof File) {
        formData.append('profilePicture', newCommunity.profilePicture);
      }

      const response = await fetch(`${apiUrl}/communitymaster`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        showSnackbar('Community created successfully! Waiting for admin approval.', 'success');
        setCreateDialogOpen(false);
        setNewCommunity({
          communityName: '',
          description: '',
          type: 'public',
          category: '',
          userId: currentUserId,
          createdBy: currentUserName,
          profilePicture: null
        });
        setProfileImagePreview(null);

        // Refresh communities list
        fetchAllCommunities();
        fetchMyCommunities();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create community');
      }
    } catch (error) {
      console.error('Error creating community:', error);
      showSnackbar(error.message || 'Error creating community', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Handle profile picture upload
  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showSnackbar('File size should be less than 5MB', 'error');
        return;
      }

      setNewCommunity({ ...newCommunity, profilePicture: file });

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Join community
  const handleJoinCommunity = async (community) => {
    if (!currentUserId) {
      showSnackbar('Please login to join communities', 'warning');
      return;
    }

    try {
      const memberRequest = {
        communityId: community.communityId,
        userId: currentUserId,
        status: 'pending',
        userName: currentUserName
      };

      const response = await fetch(`${apiUrl}/communitymaster/member/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(memberRequest),
      });

      if (response.ok) {
        // Create notification for community owner
        const notification = {
          communityId: community.communityId,
          fromUserId: currentUserId,
          toUserId: community.userId,
          type: 'join_request',
          message: `${currentUserName} wants to join your community "${community.communityName}"`,
          fromUserName: currentUserName,
          communityName: community.communityName
        };

        await fetch(`${apiUrl}/communitymaster/notification`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(notification),
        });

        showSnackbar('Join request sent! The community owner will review your request.', 'success');

        // Update community status to pending
        setCommunityStatus(prev => ({ ...prev, [community.communityId]: 'pending' }));

        // Refresh notifications
        fetchNotifications();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to send join request');
      }
    } catch (error) {
      console.error('Error joining community:', error);
      showSnackbar(error.message || 'Error sending join request', 'error');
    }
  };

  // Approve member request
  const handleApproveMember = async (memberId, communityId) => {
    try {
      const response = await fetch(`${apiUrl}/communitymaster/member/approve/${memberId}`, {
        method: 'PUT',
      });

      if (response.ok) {
        showSnackbar('Member request approved!', 'success');
        fetchMemberRequests();
        fetchNotifications();
        fetchAllCommunities();

        // Refresh community status for the approved user
        if (selectedCommunity) {
          checkMembership(selectedCommunity.communityId);
        }
      } else {
        throw new Error('Failed to approve member');
      }
    } catch (error) {
      console.error('Error approving member:', error);
      showSnackbar('Error approving member', 'error');
    }
  };

  // Reject member request
  const handleRejectMember = async (memberId) => {
    try {
      const response = await fetch(`${apiUrl}/communitymaster/member/reject/${memberId}`, {
        method: 'PUT',
      });

      if (response.ok) {
        showSnackbar('Member request rejected!', 'success');
        fetchMemberRequests();
      } else {
        throw new Error('Failed to reject member');
      }
    } catch (error) {
      console.error('Error rejecting member:', error);
      showSnackbar('Error rejecting member', 'error');
    }
  };

  // Delete notification
  const handleDeleteNotification = async (notificationId) => {
    try {
      const response = await fetch(`${apiUrl}/communitymaster/notification/${notificationId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        showSnackbar('Notification deleted', 'success');
        fetchNotifications();
      } else {
        throw new Error('Failed to delete notification');
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
      showSnackbar('Error deleting notification', 'error');
    }
  };

  // Fetch community members
  const fetchCommunityMembers = async (communityId) => {
    setLoadingMembers(true);
    try {
      const response = await fetch(`${apiUrl}/communitymaster/members/details/${communityId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedMembers(data);
        setMembersDialogOpen(true);
      } else {
        throw new Error('Failed to fetch members');
      }
    } catch (error) {
      console.error('Error fetching members:', error);
      showSnackbar('Error fetching members', 'error');
    } finally {
      setLoadingMembers(false);
    }
  };

  // Fetch post likes
  const fetchPostLikes = async (postId) => {
    setLoadingLikes(true);
    try {
      const response = await fetch(`${apiUrl}/communitymaster/likes/details/${postId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedLikes(data);
        setLikesDialogOpen(true);
      } else {
        throw new Error('Failed to fetch likes');
      }
    } catch (error) {
      console.error('Error fetching likes:', error);
      showSnackbar('Error fetching likes', 'error');
    } finally {
      setLoadingLikes(false);
    }
  };

  // Create post with image
  const handleCreatePost = async (communityId) => {
    if (!newPost.content.trim() && !newPost.imageFile) {
      showSnackbar('Please add content or an image', 'warning');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('communityId', communityId);
      formData.append('userId', currentUserId);
      formData.append('content', newPost.content);
      formData.append('userName', currentUserName);

      if (newPost.imageFile) {
        formData.append('image', newPost.imageFile);
      }

      const response = await fetch(`${apiUrl}/communitymaster/post`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        showSnackbar('Post created successfully!', 'success');
        setNewPost({ content: '', imageFile: null, imagePreview: null });
        fetchCommunityPosts(communityId);
      } else {
        throw new Error('Failed to create post');
      }
    } catch (error) {
      console.error('Error creating post:', error);
      showSnackbar('Error creating post', 'error');
    }
  };

  // Handle post image upload
  const handlePostImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showSnackbar('File size should be less than 5MB', 'error');
        return;
      }

      setNewPost({ ...newPost, imageFile: file });

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewPost(prev => ({ ...prev, imagePreview: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Like post
  const handleLikePost = async (postId) => {
    if (!currentUserId) {
      showSnackbar('Please login to like posts', 'warning');
      return;
    }

    try {
      const likeData = {
        postId: postId,
        userId: currentUserId,
        userName: currentUserName
      };

      const response = await fetch(`${apiUrl}/communitymaster/like`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(likeData),
      });

      if (response.ok) {
        const result = await response.json();
        fetchCommunityPosts(selectedCommunity.communityId);
        checkUserLike(postId);
      } else {
        throw new Error('Failed to like post');
      }
    } catch (error) {
      console.error('Error liking post:', error);
      showSnackbar('Error liking post', 'error');
    }
  };

  // Add comment
  const handleAddComment = async (postId) => {
    if (!comment.trim()) return;

    try {
      const commentData = {
        postId: postId,
        userId: currentUserId,
        content: comment,
        userName: currentUserName
      };

      const response = await fetch(`${apiUrl}/communitymaster/comment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(commentData),
      });

      if (response.ok) {
        showSnackbar('Comment added!', 'success');
        setComment('');
        fetchPostComments(postId);
        fetchCommunityPosts(selectedCommunity.communityId);
      } else {
        throw new Error('Failed to add comment');
      }
    } catch (error) {
      console.error('Error adding comment:', error);
      showSnackbar('Error adding comment', 'error');
    }
  };

  // Fetch post comments
  const fetchPostComments = async (postId) => {
    try {
      const response = await fetch(`${apiUrl}/communitymaster/comments/${postId}`);
      if (response.ok) {
        const data = await response.json();
        setPostComments(prev => ({ ...prev, [postId]: data }));
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  // Delete community
  const handleDeleteCommunity = async (communityId) => {
    if (!window.confirm('Are you sure you want to delete this community?')) return;

    try {
      const response = await fetch(`${apiUrl}/communitymaster/${communityId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        showSnackbar('Community deleted successfully!', 'success');
        fetchAllCommunities();
        fetchMyCommunities();
      } else {
        throw new Error('Failed to delete community');
      }
    } catch (error) {
      console.error('Error deleting community:', error);
      showSnackbar('Error deleting community', 'error');
    }
  };

  // Delete post
  const handleDeletePost = async (postId) => {
    if (!window.confirm('Are you sure you want to delete this post?')) return;

    try {
      const response = await fetch(`${apiUrl}/communitymaster/post/${postId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        showSnackbar('Post deleted successfully!', 'success');
        fetchCommunityPosts(selectedCommunity.communityId);
      } else {
        throw new Error('Failed to delete post');
      }
    } catch (error) {
      console.error('Error deleting post:', error);
      showSnackbar('Error deleting post', 'error');
    }
  };

  // Snackbar utility
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Check if user owns the community
  const isCommunityOwner = (community) => {
    return community.userId === currentUserId;
  };

  // Get community status text and color
  const getCommunityStatusInfo = (communityId) => {
    const status = communityStatus[communityId];

    if (!status || status === 'not_joined') {
      return {
        text: 'Join Community',
        color: 'primary',
        variant: 'outlined',
        icon: <PersonAdd />,
        loading: checkingStatus[communityId] || false
      };
    }

    if (status === 'pending') {
      return {
        text: 'Request Pending',
        color: 'warning',
        variant: 'contained',
        icon: <HourglassEmpty />,
        loading: true
      };
    }

    if (status === 'approved') {
      return {
        text: 'Joined',
        color: 'success',
        variant: 'contained',
        icon: <Check />,
        loading: false
      };
    }

    if (status === 'rejected') {
      return {
        text: 'Join Community',
        color: 'primary',
        variant: 'outlined',
        icon: <PersonAdd />,
        loading: false
      };
    }

    return {
      text: 'Join Community',
      color: 'primary',
      variant: 'outlined',
      icon: <PersonAdd />,
      loading: false
    };
  };

  // Initialize data
  useEffect(() => {
    fetchAllCommunities();
    if (currentUserId) {
      fetchMyCommunities();
      fetchNotifications();
    }
  }, [currentUserId]);

  useEffect(() => {
    if (myCommunities.length > 0) {
      fetchMemberRequests();
    }
  }, [myCommunities]);

  useEffect(() => {
    if (selectedCommunity) {
      fetchCommunityPosts(selectedCommunity.communityId);
      checkMembership(selectedCommunity.communityId);
      fetchCommunityStatus(selectedCommunity.communityId);
    }
  }, [selectedCommunity, currentUserId]);

  // Update status when communities change
  useEffect(() => {
    if (currentUserId && communities.length > 0) {
      fetchAllCommunityStatus();
    }
  }, [communities, currentUserId]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const formatJoinDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  const formatLikeDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };


  // Update community profile
  const handleUpdateCommunityProfile = async () => {
    if (!editCommunityData.communityName.trim() ||
      !editCommunityData.description.trim() ||
      !editCommunityData.category.trim()) {
      showSnackbar('Please fill all required fields', 'error');
      return;
    }

    try {
      setEditing(true);
      const formData = new FormData();
      formData.append('communityName', editCommunityData.communityName);
      formData.append('description', editCommunityData.description);
      formData.append('category', editCommunityData.category);
      formData.append('type', editCommunityData.type);

      if (editCommunityData.profilePicture instanceof File) {
        formData.append('profilePicture', editCommunityData.profilePicture);
      }

      const response = await fetch(`${apiUrl}/communitymaster/profile/${editCommunityData.communityId}`, {
        method: 'PUT',
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        showSnackbar('Community profile updated successfully!', 'success');
        setEditDialogOpen(false);
        setEditCommunityData({
          communityId: null,
          communityName: '',
          description: '',
          category: '',
          type: 'public',
          profilePicture: null
        });
        setEditProfilePreview(null);

        // Refresh communities list
        fetchAllCommunities();
        fetchMyCommunities();

        // Update selected community if it's the same
        if (selectedCommunity && selectedCommunity.communityId === editCommunityData.communityId) {
          setSelectedCommunity(result);
        }
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update community profile');
      }
    } catch (error) {
      console.error('Error updating community profile:', error);
      showSnackbar(error.message || 'Error updating community profile', 'error');
    } finally {
      setEditing(false);
    }
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box className={classes.header}>
          <Typography variant="h3" gutterBottom>
            Community Hub
          </Typography>
          <Typography variant="h6">
            Connect, share, and grow with like-minded individuals
          </Typography>
          <Button
            variant="contained"
            className={classes.createButton}
            startIcon={<Add />}
            onClick={() => {
              if (!currentUserId) {
                history.push('/login');
              } else {
                setCreateDialogOpen(true);
              }
            }}
            sx={{ mt: 2 }}
          >
            {currentUserId ? 'Create Community' : 'Login to Create Community'}
          </Button>
          {!currentUserId && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Please login to create and join communities
            </Typography>
          )}
        </Box>

        {/* Tabs */}
        <div style={{ position: 'relative', marginBottom: '100px' }}>
          <AppBar
            sx={{
              borderRadius: 2,
              position: 'absolute !important',
            }}
            color="default"
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="All Communities" icon={<Public />} />
              <Tab label="My Communities" icon={<Group />} />
              <Tab
                label={
                  <Badge badgeContent={notifications.length + memberRequests.length} color="error">
                    Notifications
                  </Badge>
                }
                icon={<Notifications />}
              />
            </Tabs>
          </AppBar>
        </div>

        {/* All Communities Tab */}
        <TabPanel value={tabValue} index={0}>
          {loading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              {communities.map((community) => {
                const statusInfo = getCommunityStatusInfo(community.communityId);
                return (
                  <Grid item xs={12} sm={6} md={4} key={community.communityId || community._id}>
                    <Card className={classes.communityCard}>
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Box display="flex" alignItems="center" mb={2}>
                          <Avatar
                            sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
                            src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
                          >
                            {!community.profilePicture && <Group />}
                          </Avatar>
                          <Box>
                            <Typography variant="h6" gutterBottom>
                              {community.communityName}
                            </Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Chip
                                label={community.type || 'public'}
                                size="small"
                                color={community.type === 'public' ? 'primary' : 'secondary'}
                              />
                              {isCommunityOwner(community) && (
                                <Chip
                                  label="Owner"
                                  size="small"
                                  color="success"
                                />
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Typography variant="body2" color="text.secondary" paragraph>
                          {community.description}
                        </Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Typography variant="body2" color="text.secondary">
                            <People sx={{ fontSize: 16, mr: 0.5 }} />
                            <span
                              className={classes.clickableCount}
                              onClick={() => fetchCommunityMembers(community.communityId)}
                            >
                              {community.members || 1} members
                            </span>
                          </Typography>
                          <Chip label={community.category} variant="outlined" size="small" />
                        </Box>
                      </CardContent>
                      <CardActions>
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => setSelectedCommunity(community)}
                        >
                          View Details
                        </Button>
                        {!isCommunityOwner(community) && (
                          <Button
                            size="small"
                            color={statusInfo.color}
                            variant={statusInfo.variant}
                            onClick={() => {
                              const status = communityStatus[community.communityId];
                              if (!status || status === 'not_joined' || status === 'rejected') {
                                handleJoinCommunity(community);
                              }
                            }}
                            disabled={!currentUserId ||
                              statusInfo.loading ||
                              communityStatus[community.communityId] === 'pending' ||
                              communityStatus[community.communityId] === 'approved'}
                            startIcon={
                              statusInfo.loading ? (
                                <CircularProgress size={16} />
                              ) : (
                                statusInfo.icon
                              )
                            }
                          >
                            {statusInfo.text}
                          </Button>
                        )}
                        {isCommunityOwner(community) && (
                          <Button
                            size="small"
                            color="error"
                            onClick={() => handleDeleteCommunity(community.communityId)}
                          >
                            Delete
                          </Button>
                        )}
                      </CardActions>
                    </Card>
                  </Grid>
                );
              })}
              {communities.length === 0 && (
                <Grid item xs={12}>
                  <Typography variant="h6" textAlign="center" color="text.secondary">
                    No approved communities found. Create one or wait for admin approval.
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </TabPanel>

        {/* My Communities Tab */}

        {/* My Communities Tab */}
        <TabPanel value={tabValue} index={1}>
          {!currentUserId ? (
            <Typography variant="h6" textAlign="center" color="text.secondary">
              Please login to view your communities
            </Typography>
          ) : loading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Typography variant="h5" gutterBottom>
                My Communities
              </Typography>
              <Grid container spacing={3}>
                {myCommunities.map((community) => {
                  const isPending = community.status === 'pending';
                  const isApproved = community.status === 'approved';
                  const isRejected = community.status === 'rejected';

                  return (
                    <Grid item xs={12} key={community.communityId || community._id}>
                      <Card className={classes.communityCard}>
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={3}>
                            <Avatar
                              sx={{
                                bgcolor: isPending ? '#ff9800' : isApproved ? '#667eea' : isRejected ? '#f44336' : '#9e9e9e',
                                mr: 2,
                                width: 60,
                                height: 60
                              }}
                              src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
                            >
                              {!community.profilePicture && <Group />}
                            </Avatar>
                            <Box flexGrow={1}>
                              <Box display="flex" alignItems="center" gap={1} mb={1}>
                                <Typography variant="h6">
                                  {community.communityName}
                                </Typography>
                                <Chip
                                  label={
                                    isPending ? 'Pending Approval' :
                                      isApproved ? 'Approved' :
                                        isRejected ? 'Rejected' : 'Unknown'
                                  }
                                  size="small"
                                  color={
                                    isPending ? 'warning' :
                                      isApproved ? 'success' :
                                        isRejected ? 'error' : 'default'
                                  }
                                />
                              </Box>
                              <Typography variant="body2" color="text.secondary" paragraph>
                                {community.description}
                              </Typography>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Typography variant="body2" color="text.secondary">
                                  <People sx={{ fontSize: 16, mr: 0.5 }} />
                                  {community.members || 1} members
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Category: {community.category}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>

                          {/* Status Messages */}
                          {isPending && (
                            <Box
                              sx={{
                                backgroundColor: '#fff3e0',
                                p: 2,
                                borderRadius: 1,
                                mb: 3,
                                borderLeft: '4px solid #ff9800'
                              }}
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <HourglassEmpty sx={{ color: '#ff9800' }} />
                                <Typography variant="body2" color="text.secondary">
                                  <strong>Waiting for admin approval.</strong> Your community is under review.
                                  You will be able to post and manage members once approved.
                                </Typography>
                              </Box>
                            </Box>
                          )}

                          {isRejected && community.rejectionReason && (
                            <Box
                              sx={{
                                backgroundColor: '#ffebee',
                                p: 2,
                                borderRadius: 1,
                                mb: 3,
                                borderLeft: '4px solid #f44336'
                              }}
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <Cancel sx={{ color: '#f44336' }} />
                                <Typography variant="body2" color="text.secondary">
                                  <strong>Community Rejected:</strong> {community.rejectionReason}
                                </Typography>
                              </Box>
                            </Box>
                          )}

                          {/* Create Post Section - Only for approved communities */}
                          {isApproved && (
                            <>
                              <Box mb={3}>
                                <TextField
                                  fullWidth
                                  variant="outlined"
                                  placeholder="Share something with the community..."
                                  value={newPost.content}
                                  onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
                                  multiline
                                  rows={2}
                                />

                                {/* Image upload for post */}
                                <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <input
                                    accept="image/*"
                                    className={classes.fileInput}
                                    id="post-image-upload"
                                    type="file"
                                    onChange={handlePostImageChange}
                                  />
                                  <label htmlFor="post-image-upload">
                                    <IconButton color="primary" component="span">
                                      <AddPhotoAlternate />
                                    </IconButton>
                                  </label>
                                  {newPost.imagePreview && (
                                    <>
                                      <Typography variant="caption">
                                        Image selected
                                      </Typography>
                                      <IconButton
                                        size="small"
                                        onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
                                      >
                                        <Cancel fontSize="small" />
                                      </IconButton>
                                    </>
                                  )}
                                </Box>

                                {/* Image preview */}
                                {newPost.imagePreview && (
                                  <Box sx={{ mt: 1 }}>
                                    <img
                                      src={newPost.imagePreview}
                                      alt="Preview"
                                      className={classes.imagePreview}
                                    />
                                  </Box>
                                )}

                                <Box mt={1} display="flex" justifyContent="flex-end">
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreatePost(community.communityId)}
                                    disabled={(!newPost.content.trim() && !newPost.imageFile)}
                                  >
                                    Post
                                  </Button>
                                </Box>
                              </Box>
                            </>
                          )}

                          {/* Action Buttons */}
                          <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                            <Box display="flex" gap={1}>
                              {isApproved && (
                                <>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => fetchCommunityMembers(community.communityId)}
                                    startIcon={<People />}
                                  >
                                    View Members ({community.members || 1})
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => setSelectedCommunity(community)}
                                  >
                                    View Posts
                                  </Button>
                                </>
                              )}
                            </Box>

                            <Box display="flex" gap={1}>
                              {isApproved && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  startIcon={<Edit />}
                                  onClick={() => {
                                    setEditCommunityData({
                                      communityId: community.communityId,
                                      communityName: community.communityName,
                                      description: community.description,
                                      category: community.category,
                                      type: community.type || 'public',
                                      profilePicture: null
                                    });
                                    setEditProfilePreview(null);
                                    setEditDialogOpen(true);
                                  }}
                                >
                                  Edit Profile
                                </Button>
                              )}
                              <Button
                                size="small"
                                color="error"
                                onClick={() => handleDeleteCommunity(community.communityId)}
                              >
                                Delete
                              </Button>
                            </Box>
                          </Box>

                          {/* Pending Message for all buttons */}
                          {isPending && (
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                              All features will be available after admin approval
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
                {myCommunities.length === 0 && (
                  <Grid item xs={12}>
                    <Card className={classes.communityCard}>
                      <CardContent sx={{ textAlign: 'center', py: 4 }}>
                        <Group sx={{ fontSize: 60, color: '#9e9e9e', mb: 2 }} />
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                          No Communities Yet
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph>
                          You haven't created any communities yet.
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<Add />}
                          onClick={() => setCreateDialogOpen(true)}
                        >
                          Create Your First Community
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </TabPanel>

        {/* <TabPanel value={tabValue} index={1}>
          {!currentUserId ? (
            <Typography variant="h6" textAlign="center" color="text.secondary">
              Please login to view your communities
            </Typography>
          ) : loading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Typography variant="h5" gutterBottom>
                Communities You've Created
              </Typography>
              <Grid container spacing={3}>
                {myCommunities.map((community) => (
                  <Grid item xs={12} key={community.communityId || community._id}>
                    <Card className={classes.communityCard}>
                      <CardContent>
                        <Box display="flex" alignItems="center" mb={3}>
                          <Avatar
                            sx={{ bgcolor: '#667eea', mr: 2, width: 60, height: 60 }}
                            src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
                          >
                            {!community.profilePicture && <Group />}
                          </Avatar>
                          <Box flexGrow={1}>
                            <Typography variant="h6" gutterBottom>
                              {community.communityName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                              {community.description}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Chip
                              label={`${community.members || 1} members`}
                              color="primary"
                              variant="outlined"
                              onClick={() => fetchCommunityMembers(community.communityId)}
                              sx={{ cursor: 'pointer' }}
                            />

                            <Box display="flex" gap={1}>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<Edit />}
                                onClick={() => {
                                  setEditCommunityData({
                                    communityId: community.communityId,
                                    communityName: community.communityName,
                                    description: community.description,
                                    category: community.category,
                                    type: community.type || 'public',
                                    profilePicture: null
                                  });
                                  setEditProfilePreview(null);
                                  setEditDialogOpen(true);
                                }}
                              >
                                Edit Profile
                              </Button>
                              <Button
                                size="small"
                                color="error"
                                onClick={() => handleDeleteCommunity(community.communityId)}
                              >
                                Delete
                              </Button>
                            </Box>
                          </Box>
                        </Box>

                        <Box mb={3}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Share something with the community..."
                            value={newPost.content}
                            onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
                            multiline
                            rows={2}
                          />

                          <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              accept="image/*"
                              className={classes.fileInput}
                              id="post-image-upload"
                              type="file"
                              onChange={handlePostImageChange}
                            />
                            <label htmlFor="post-image-upload">
                              <IconButton color="primary" component="span">
                                <AddPhotoAlternate />
                              </IconButton>
                            </label>
                            {newPost.imagePreview && (
                              <>
                                <Typography variant="caption">
                                  Image selected
                                </Typography>
                                <IconButton
                                  size="small"
                                  onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
                                >
                                  <Cancel fontSize="small" />
                                </IconButton>
                              </>
                            )}
                          </Box>

                          {newPost.imagePreview && (
                            <Box sx={{ mt: 1 }}>
                              <img
                                src={newPost.imagePreview}
                                alt="Preview"
                                className={classes.imagePreview}
                              />
                            </Box>
                          )}

                          <Box mt={1} display="flex" justifyContent="flex-end">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleCreatePost(community.communityId)}
                              disabled={(!newPost.content.trim() && !newPost.imageFile)}
                            >
                              Post
                            </Button>
                          </Box>
                        </Box>

                        <Box mt={2}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setSelectedCommunity(community)}
                          >
                            View Community Posts
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
                {myCommunities.length === 0 && (
                  <Grid item xs={12}>
                    <Typography variant="h6" textAlign="center" color="text.secondary">
                      You haven't created any communities yet or your communities are pending approval.
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </TabPanel> */}

        {/* Notifications Tab */}
        <TabPanel value={tabValue} index={2}>
          <Typography variant="h5" gutterBottom>
            Notifications
          </Typography>

          {/* Member Requests */}
          {memberRequests.length > 0 && (
            <Box mb={4}>
              <Typography variant="h6" gutterBottom>
                Member Requests ({memberRequests.length})
              </Typography>
              <List>
                {memberRequests.map((request) => (
                  <ListItem
                    key={request.memberId}
                    className={classes.notificationItem}
                    component={Paper}
                    elevation={1}
                    sx={{ mb: 2, p: 2 }}
                  >
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#667eea' }}>
                        <Group />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`Join request from ${request.userName}`}
                      secondary={
                        <Box>
                          <Typography variant="body2" color="text.secondary">
                            {request.communityName} • {formatDate(request.createdAt)}
                          </Typography>
                          <Box mt={1} display="flex" gap={1}>
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              startIcon={<CheckCircle />}
                              onClick={() => handleApproveMember(request.memberId, request.communityId)}
                            >
                              Approve
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="secondary"
                              startIcon={<Cancel />}
                              onClick={() => handleRejectMember(request.memberId)}
                            >
                              Decline
                            </Button>
                          </Box>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}

          {/* Other Notifications */}
          <List>
            {notifications.map((notification) => (
              <ListItem
                key={notification.notificationId}
                className={classes.notificationItem}
                component={Paper}
                elevation={1}
                sx={{ mb: 2, p: 2 }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: '#667eea' }}>
                    <Notifications />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={notification.message}
                  secondary={
                    <Typography variant="body2" color="text.secondary">
                      {notification.communityName} • {formatDate(notification.createdAt)}
                    </Typography>
                  }
                />
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDeleteNotification(notification.notificationId)}
                  title="Delete Notification"
                >
                  <Close fontSize="small" />
                </IconButton>
              </ListItem>
            ))}
            {notifications.length === 0 && memberRequests.length === 0 && (
              <Typography variant="body2" color="text.secondary" textAlign="center">
                No notifications yet.
              </Typography>
            )}
          </List>
        </TabPanel>

        {/* Community Details Dialog with Posts */}
        <Dialog
          open={!!selectedCommunity}
          onClose={() => setSelectedCommunity(null)}
          maxWidth="md"
          fullWidth
          scroll="paper"
        >
          {selectedCommunity && (
            <>
              <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <Avatar
                      sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
                      src={selectedCommunity.profilePicture ? `${apiUrl}${selectedCommunity.profilePicture}` : undefined}
                    >
                      {!selectedCommunity.profilePicture && <Group />}
                    </Avatar>
                    <Box>
                      <Typography variant="h6">{selectedCommunity.communityName}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedCommunity.description}
                      </Typography>
                    </Box>
                  </Box>

                  {selectedCommunity.status === 'pending' && (
                    <Chip
                      label="Pending Approval"
                      color="warning"
                      size="small"
                    />
                  )}
                </Box>
              </DialogTitle>
              <DialogContent>

                {/* Only show content if community is approved */}
                {selectedCommunity.status === 'approved' ? (
                  <>


                    <Box display="flex" gap={2} mb={2} flexWrap="wrap">
                      <Chip
                        label={`${selectedCommunity.members || 1} members`}
                        onClick={() => fetchCommunityMembers(selectedCommunity.communityId)}
                        sx={{ cursor: 'pointer' }}
                      />
                      <Chip label={selectedCommunity.type || 'public'} color="primary" />
                      <Chip label={selectedCommunity.category} variant="outlined" />
                      {isCommunityOwner(selectedCommunity) && (
                        <Chip label="You are the owner" color="success" />
                      )}
                      {isMember && !isCommunityOwner(selectedCommunity) && (
                        <Chip label="Member" color="primary" variant="outlined" />
                      )}
                    </Box>

                    {/* Create Post (for members and owner) */}
                    {(isCommunityOwner(selectedCommunity) || isMember) && (
                      <Box mb={3}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Share something with the community..."
                          value={newPost.content}
                          onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
                          multiline
                          rows={2}
                        />

                        {/* Image upload for post */}
                        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                          <input
                            accept="image/*"
                            className={classes.fileInput}
                            id="community-post-image-upload"
                            type="file"
                            onChange={handlePostImageChange}
                          />
                          <label htmlFor="community-post-image-upload">
                            <IconButton color="primary" component="span">
                              <AddPhotoAlternate />
                            </IconButton>
                          </label>
                          {newPost.imagePreview && (
                            <>
                              <Typography variant="caption">
                                Image selected
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
                              >
                                <Cancel fontSize="small" />
                              </IconButton>
                            </>
                          )}
                        </Box>

                        {/* Image preview */}
                        {newPost.imagePreview && (
                          <Box sx={{ mt: 1 }}>
                            <img
                              src={newPost.imagePreview}
                              alt="Preview"
                              className={classes.imagePreview}
                            />
                          </Box>
                        )}

                        <Box mt={1} display="flex" justifyContent="flex-end">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleCreatePost(selectedCommunity.communityId)}
                            disabled={!newPost.content.trim() && !newPost.imageFile}
                          >
                            Post
                          </Button>
                        </Box>
                      </Box>
                    )}

                    {/* Posts */}
                    <Typography variant="h6" gutterBottom>
                      Community Posts
                    </Typography>
                    {communityPosts.length > 0 ? (
                      communityPosts.map((post) => (
                        <Paper key={post.postId} className={classes.postCard} elevation={1}>
                          {/* Post Header */}
                          <Box className={classes.postHeader}>
                            <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
                              {post.userName?.charAt(0) || 'U'}
                            </Avatar>
                            <Box flexGrow={1}>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {post.userName}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {formatDate(post.createdAt)}
                              </Typography>
                            </Box>
                            {isCommunityOwner(selectedCommunity) && (
                              <Tooltip title="Delete Post">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDeletePost(post.postId)}
                                >
                                  <Delete fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>

                          {/* Post Content */}
                          <CardContent>
                            {post.content && (
                              <Typography variant="body1" paragraph>
                                {post.content}
                              </Typography>
                            )}
                            {post.imageUrl && (
                              <Box sx={{ mt: 2 }}>
                                <img
                                  src={`${apiUrl}${post.imageUrl}`}
                                  alt="Post"
                                  className={classes.imagePreview}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
                                  }}
                                />
                              </Box>
                            )}
                          </CardContent>

                          {/* Action Buttons */}
                          <Box className={classes.actionButtons}>
                            <Box display="flex" alignItems="center">
                              <IconButton
                                onClick={() => handleLikePost(post.postId)}
                                color={userLikes[post.postId] ? 'error' : 'default'}
                              >
                                {userLikes[post.postId] ? <Favorite /> : <FavoriteBorder />}
                              </IconButton>
                              <Typography
                                variant="body2"
                                sx={{ ml: 1, cursor: 'pointer' }}
                                className={classes.clickableCount}
                                onClick={() => fetchPostLikes(post.postId)}
                              >
                                {post.likes || 0} likes
                              </Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                              <IconButton onClick={() => fetchPostComments(post.postId)}>
                                <Comment fontSize="small" />
                              </IconButton>
                              <Typography variant="body2" sx={{ ml: 1 }}>
                                {post.comments || 0} comments
                              </Typography>
                            </Box>
                            <IconButton>
                              <Share fontSize="small" />
                              <Typography variant="body2" sx={{ ml: 1 }}>
                                {post.shares || 0}
                              </Typography>
                            </IconButton>
                          </Box>

                          {/* Comments Section */}
                          {postComments[post.postId] && (
                            <Box className={classes.commentSection}>
                              <Typography variant="subtitle2" gutterBottom>
                                Comments:
                              </Typography>
                              {postComments[post.postId].map((commentItem) => (
                                <Box key={commentItem.commentId} mb={1}>
                                  <Typography variant="body2" fontWeight="bold">
                                    {commentItem.userName}
                                  </Typography>
                                  <Typography variant="body2">
                                    {commentItem.content}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {formatDate(commentItem.createdAt)}
                                  </Typography>
                                  <Divider sx={{ mt: 1 }} />
                                </Box>
                              ))}

                              {/* Add Comment */}
                              <Box mt={2} display="flex">
                                <TextField
                                  fullWidth
                                  size="small"
                                  placeholder="Write a comment..."
                                  value={comment}
                                  onChange={(e) => setComment(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          color="primary"
                                          onClick={() => handleAddComment(post.postId)}
                                          disabled={!comment.trim()}
                                        >
                                          <Send />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                        </Paper>
                      ))
                    ) : (
                      <Typography color="text.secondary" textAlign="center">
                        No posts yet. Be the first to post!
                      </Typography>
                    )}

                  </>
                ) : selectedCommunity.status === 'pending' ? (
                  <Box
                    sx={{
                      backgroundColor: '#fff3e0',
                      p: 3,
                      borderRadius: 2,
                      textAlign: 'center',
                      my: 4
                    }}
                  >
                    <HourglassEmpty sx={{ fontSize: 60, color: '#ff9800', mb: 2 }} />
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                      Community Pending Approval
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      This community is waiting for admin approval.
                      Posts and members will be visible once the community is approved.
                    </Typography>
                  </Box>
                ) : selectedCommunity.status === 'rejected' ? (
                  <Box
                    sx={{
                      backgroundColor: '#ffebee',
                      p: 3,
                      borderRadius: 2,
                      textAlign: 'center',
                      my: 4
                    }}
                  >
                    <Cancel sx={{ fontSize: 60, color: '#f44336', mb: 2 }} />
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                      Community Rejected
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {selectedCommunity.rejectionReason || 'This community has been rejected by admin.'}
                    </Typography>
                  </Box>
                ) : null}

              </DialogContent>
              <DialogActions>
                <Button onClick={() => setSelectedCommunity(null)}>Close</Button>
              </DialogActions>
            </>
          )}
        </Dialog>

        {/* Create Community Dialog */}
        <Dialog
          open={createDialogOpen}
          onClose={() => setCreateDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Create New Community</DialogTitle>
          <DialogContent>
            <Box component="form" sx={{ mt: 2 }}>
              <TextField
                autoFocus
                margin="dense"
                label="Community Name *"
                fullWidth
                variant="outlined"
                value={newCommunity.communityName}
                onChange={(e) => setNewCommunity({ ...newCommunity, communityName: e.target.value })}
                required
              />
              <TextField
                margin="dense"
                label="Description *"
                fullWidth
                variant="outlined"
                multiline
                rows={3}
                value={newCommunity.description}
                onChange={(e) => setNewCommunity({ ...newCommunity, description: e.target.value })}
                required
              />
              <TextField
                margin="dense"
                label="Category *"
                fullWidth
                variant="outlined"
                value={newCommunity.category}
                onChange={(e) => setNewCommunity({ ...newCommunity, category: e.target.value })}
                required
              />

              {/* Profile Picture Upload */}
              <Box sx={{ mt: 2, mb: 2 }}>
                <input
                  accept="image/*"
                  className={classes.fileInput}
                  id="profile-picture-upload"
                  type="file"
                  onChange={handleProfilePictureChange}
                />
                <label htmlFor="profile-picture-upload">
                  <Button variant="outlined" component="span" startIcon={<AddPhotoAlternate />}>
                    Upload Profile Picture
                  </Button>
                </label>
                {profileImagePreview && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="caption">Preview:</Typography>
                    <img
                      src={profileImagePreview}
                      alt="Profile Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        marginTop: '8px',
                        border: '1px solid #dee2e6'
                      }}
                    />
                  </Box>
                )}
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                  Optional: Upload a profile picture for your community (JPEG, PNG, WEBP, max 5MB)
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCreateDialogOpen(false)}>Cancel</Button>
            <Button
              onClick={handleCreateCommunity}
              variant="contained"
              color="primary"
              disabled={!newCommunity.communityName.trim() ||
                !newCommunity.description.trim() ||
                !newCommunity.category.trim() ||
                loading}
            >
              {loading ? 'Creating...' : 'Create Community'}
            </Button>
          </DialogActions>
        </Dialog>


        {/* Edit Community Profile Dialog */}
        <Dialog
          open={editDialogOpen}
          onClose={() => setEditDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Edit Community Profile</DialogTitle>
          <DialogContent>
            <Box component="form" sx={{ mt: 2 }}>
              <TextField
                autoFocus
                margin="dense"
                label="Community Name *"
                fullWidth
                variant="outlined"
                value={editCommunityData.communityName}
                onChange={(e) => setEditCommunityData({ ...editCommunityData, communityName: e.target.value })}
                required
              />
              <TextField
                margin="dense"
                label="Description *"
                fullWidth
                variant="outlined"
                multiline
                rows={3}
                value={editCommunityData.description}
                onChange={(e) => setEditCommunityData({ ...editCommunityData, description: e.target.value })}
                required
              />
              <TextField
                margin="dense"
                label="Category *"
                fullWidth
                variant="outlined"
                value={editCommunityData.category}
                onChange={(e) => setEditCommunityData({ ...editCommunityData, category: e.target.value })}
                required
              />

              {/* Current Profile Picture */}
              {selectedCommunity?.profilePicture && (
                <Box sx={{ mt: 2, mb: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Current Profile Picture:
                  </Typography>
                  <Box sx={{ textAlign: 'center' }}>
                    <img
                      src={`${apiUrl}${selectedCommunity.profilePicture}`}
                      alt="Current Profile"
                      style={{
                        width: '150px',
                        height: '150px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/150x150?text=No+Image';
                      }}
                    />
                  </Box>
                </Box>
              )}

              {/* New Profile Picture Upload */}
              <Box sx={{ mt: 2, mb: 2 }}>
                <input
                  accept="image/*"
                  className={classes.fileInput}
                  id="edit-profile-picture-upload"
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
                      if (!validTypes.includes(file.type)) {
                        showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
                        return;
                      }
                      if (file.size > 5 * 1024 * 1024) {
                        showSnackbar('File size should be less than 5MB', 'error');
                        return;
                      }
                      setEditCommunityData({ ...editCommunityData, profilePicture: file });

                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setEditProfilePreview(reader.result);
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                <label htmlFor="edit-profile-picture-upload">
                  <Button variant="outlined" component="span" startIcon={<AddPhotoAlternate />}>
                    Change Profile Picture
                  </Button>
                </label>
                {editProfilePreview && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="caption">New Picture Preview:</Typography>
                    <img
                      src={editProfilePreview}
                      alt="New Profile Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        marginTop: '8px',
                        border: '1px solid #dee2e6'
                      }}
                    />
                  </Box>
                )}
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                  Optional: Upload a new profile picture (JPEG, PNG, WEBP, max 5MB)
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
            <Button
              onClick={handleUpdateCommunityProfile}
              variant="contained"
              color="primary"
              disabled={!editCommunityData.communityName.trim() ||
                !editCommunityData.description.trim() ||
                !editCommunityData.category.trim() ||
                editing}
            >
              {editing ? 'Updating...' : 'Update Profile'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Members Dialog */}
        <Dialog
          open={membersDialogOpen}
          onClose={() => setMembersDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Members
            {selectedCommunity && ` of "${selectedCommunity.communityName}"`}
          </DialogTitle>
          <DialogContent>
            {loadingMembers ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : selectedMembers.length > 0 ? (
              <List>
                {/* {selectedMembers.map((member) => (
                  <ListItem key={member.memberId}>
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#667eea' }}>
                        {member.userName?.charAt(0) || 'U'}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={member.userName}
                      secondary={
                        <Box>
                          <Typography variant="caption">
                            User ID: {member.userId}
                          </Typography>
                          <br />
                          <Typography variant="caption">
                            Joined: {formatJoinDate(member.joinedAt)}
                          </Typography>
                        </Box>
                      }
                    />
                    {member.status === 'approved' && (
                      <Chip
                        label="Member"
                        color="success"
                        size="small"
                      />
                    )}
                  </ListItem>
                ))} */}
                {/* {selectedMembers.map((member) => {
                  const isCurrentUser = member.userId === currentUserId;
                  return (
                    <ListItem
                      key={member.memberId}
                      sx={{
                        backgroundColor: isCurrentUser ? '#f0f9ff' : 'transparent',
                        borderRadius: '8px',
                        mb: 1
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            bgcolor: isCurrentUser ? '#1976d2' : '#667eea',
                            border: isCurrentUser ? '2px solid #1976d2' : 'none'
                          }}
                        >
                          {member.userName?.charAt(0) || 'U'}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body1">
                              {member.userName} {isCurrentUser && "(me)"}
                            </Typography>
                            {isCurrentUser && (
                              <Chip
                                label="Me"
                                size="small"
                                color="primary"
                                sx={{
                                  height: '20px',
                                  fontSize: '0.7rem',
                                  fontWeight: 'bold'
                                }}
                              />
                            )}
                          </Box>
                        }
                        secondary={
                          <Box>
                            <Typography variant="caption" display="block">
                              User ID: {member.userId}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Joined: {formatJoinDate(member.joinedAt)}
                            </Typography>
                          </Box>
                        }
                      />
                      {member.status === 'approved' && (
                        <Chip
                          label={isCurrentUser ? "You" : "Member"}
                          color={isCurrentUser ? "primary" : "success"}
                          size="small"
                        />
                      )}
                    </ListItem>
                  );
                })} */}

                {selectedMembers.map((member) => {
                  const isCurrentUser = member.userId === currentUserId;
                  const isOwner = selectedCommunity && member.userId === selectedCommunity.userId;

                  return (
                    <ListItem
                      key={member.memberId}
                      sx={{
                        backgroundColor: isCurrentUser ? '#f0f9ff' : 'transparent',
                        borderRadius: '8px',
                        mb: 1,
                        borderLeft: isOwner ? '4px solid #ff9800' : 'none'
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            bgcolor: isCurrentUser ? '#1976d2' : isOwner ? '#ff9800' : '#667eea',
                            border: isCurrentUser ? '2px solid #1976d2' : isOwner ? '2px solid #ff9800' : 'none'
                          }}
                        >
                          {member.userName?.charAt(0) || 'U'}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body1">
                              {member.userName}
                            </Typography>
                            {isOwner && (
                              <Chip
                                label="Owner"
                                size="small"
                                color="warning"
                                sx={{
                                  height: '20px',
                                  fontSize: '0.7rem',
                                  fontWeight: 'bold'
                                }}
                              />
                            )}
                            {isCurrentUser && !isOwner && (
                              <Chip
                                label="Me"
                                size="small"
                                color="primary"
                                sx={{
                                  height: '20px',
                                  fontSize: '0.7rem',
                                  fontWeight: 'bold'
                                }}
                              />
                            )}
                          </Box>
                        }
                        secondary={
                          <Box>
                            <Typography variant="caption" display="block">
                              User ID: {member.userId}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Joined: {formatJoinDate(member.joinedAt)}
                            </Typography>
                          </Box>
                        }
                      />
                      <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.5}>
                        {isOwner ? (
                          <Chip
                            label="Owner"
                            color="warning"
                            size="small"
                          />
                        ) : (
                          <Chip
                            label={isCurrentUser ? "You" : "Member"}
                            color={isCurrentUser ? "primary" : "success"}
                            size="small"
                          />
                        )}
                        {isCurrentUser && (
                          <Typography variant="caption" color="text.secondary">
                            ({isOwner ? "You are the owner" : "You are a member"})
                          </Typography>
                        )}
                      </Box>
                    </ListItem>
                  );
                })}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                No members found.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMembersDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Likes Dialog */}
        <Dialog
          open={likesDialogOpen}
          onClose={() => setLikesDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>People who liked this post</DialogTitle>
          <DialogContent>
            {loadingLikes ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : selectedLikes.length > 0 ? (
              <List>
                {selectedLikes.map((like) => (
                  <ListItem key={like.likeId}>
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#667eea' }}>
                        {like.userName?.charAt(0) || 'U'}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={like.userName}
                      secondary={
                        <Typography variant="caption">
                          Liked: {formatLikeDate(like.likedAt)}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                No likes yet.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setLikesDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </div>
  );
};

export default Community;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   AppBar,
//   Tabs,
//   Tab,
//   Chip,
//   Avatar,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Badge,
//   Divider,
//   Paper,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Tooltip,
//   DialogContentText,
//   CircularProgress
// } from '@mui/material';
// import {
//   ThumbUp,
//   Comment,
//   Share,
//   Group,
//   Add,
//   Notifications,
//   Public,
//   Lock,
//   People,
//   Send,
//   Favorite,
//   FavoriteBorder,
//   AddPhotoAlternate,
//   Delete,
//   CheckCircle,
//   Cancel,
//   Close,
//   PersonAdd,
//   CheckCircleOutline,
//   Person
// } from '@mui/icons-material';
// import { useHistory } from 'react-router-dom';
// import { makeStyles } from '@material-ui/core/styles';
// import { apiUrl } from '../coreservices/environment';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: '#f8f9fa',
//     minHeight: '100vh',
//     paddingTop: theme.spacing(4),
//   },
//   header: {
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     color: 'white',
//     padding: theme.spacing(4),
//     borderRadius: theme.spacing(2),
//     marginBottom: theme.spacing(4),
//   },
//   communityCard: {
//     transition: 'transform 0.2s, box-shadow 0.2s',
//     '&:hover': {
//       transform: 'translateY(-4px)',
//       boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
//     },
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   createButton: {
//     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
//     color: 'white',
//     fontWeight: 'bold',
//     padding: '12px 30px',
//     borderRadius: '25px',
//     '&:hover': {
//       transform: 'scale(1.05)',
//     },
//   },
//   tabPanel: {
//     padding: theme.spacing(3, 0),
//   },
//   postCard: {
//     marginBottom: theme.spacing(3),
//     borderRadius: '12px',
//     overflow: 'hidden',
//   },
//   postHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     borderBottom: '1px solid #e0e0e0',
//   },
//   actionButtons: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     padding: theme.spacing(1, 2),
//   },
//   commentSection: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fafafa',
//   },
//   notificationItem: {
//     borderLeft: '4px solid #667eea',
//     marginBottom: theme.spacing(1),
//     '&:hover': {
//       backgroundColor: '#f5f5f5',
//     },
//   },
//   imagePreview: {
//     maxWidth: '100%',
//     maxHeight: '400px',
//     borderRadius: '8px',
//     marginTop: theme.spacing(2),
//     objectFit: 'contain',
//   },
//   fileInput: {
//     display: 'none',
//   },
//   clickableCount: {
//     cursor: 'pointer',
//     '&:hover': {
//       textDecoration: 'underline',
//       color: theme.palette.primary.main,
//     },
//   },
//   joinedButton: {
//     backgroundColor: '#4caf50',
//     color: 'white',
//     '&:hover': {
//       backgroundColor: '#388e3c',
//     },
//   },
// }));

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`community-tabpanel-${index}`}
//       aria-labelledby={`community-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// const Community = () => {
//   const classes = useStyles();
//   const history = useHistory();
//   const [tabValue, setTabValue] = useState(0);
//   const [createDialogOpen, setCreateDialogOpen] = useState(false);
//   const [selectedCommunity, setSelectedCommunity] = useState(null);
//   const [communityPosts, setCommunityPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Get current user data from localStorage
//   const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//   const currentUserId = userData?.userId;
//   const currentUserName = userData?.firstName || 'User';

//   const [newCommunity, setNewCommunity] = useState({
//     communityName: '',
//     description: '',
//     type: 'public',
//     category: '',
//     userId: currentUserId,
//     createdBy: currentUserName,
//     profilePicture: null
//   });

//   const [newPost, setNewPost] = useState({
//     content: '',
//     imageFile: null,
//     imagePreview: null
//   });
//   const [comment, setComment] = useState('');
//   const [postComments, setPostComments] = useState({});

//   // State for dynamic data from API
//   const [communities, setCommunities] = useState([]);
//   const [myCommunities, setMyCommunities] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [memberRequests, setMemberRequests] = useState([]);
//   const [userLikes, setUserLikes] = useState({});
//   const [isMember, setIsMember] = useState(false);
//   const [profileImagePreview, setProfileImagePreview] = useState(null);
//   const [communityStatus, setCommunityStatus] = useState({});
//   const [membersDialogOpen, setMembersDialogOpen] = useState(false);
//   const [likesDialogOpen, setLikesDialogOpen] = useState(false);
//   const [selectedMembers, setSelectedMembers] = useState([]);
//   const [selectedLikes, setSelectedLikes] = useState([]);
//   const [loadingMembers, setLoadingMembers] = useState(false);
//   const [loadingLikes, setLoadingLikes] = useState(false);
//   const [communityMembers, setCommunityMembers] = useState({});

//   // Fetch all approved communities
//   const fetchAllCommunities = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${apiUrl}/communitymaster`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunities(data);

//         // Fetch community status for each community
//         if (currentUserId) {
//           data.forEach(community => {
//             fetchCommunityStatus(community.communityId);
//           });
//         }
//       } else {
//         throw new Error('Failed to fetch communities');
//       }
//     } catch (error) {
//       console.error('Error fetching communities:', error);
//       showSnackbar('Error fetching communities', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch my approved communities
//   const fetchMyCommunities = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/mycommunities/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setMyCommunities(data);
//       } else {
//         throw new Error('Failed to fetch my communities');
//       }
//     } catch (error) {
//       console.error('Error fetching my communities:', error);
//       showSnackbar('Error fetching your communities', 'error');
//     }
//   };

//   // Fetch notifications (filter out inactive)
//   const fetchNotifications = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/notifications/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setNotifications(data.filter(notification => notification.isActive));
//       } else {
//         throw new Error('Failed to fetch notifications');
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//     }
//   };

//   // Fetch community posts
//   const fetchCommunityPosts = async (communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/posts/${communityId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunityPosts(data);

//         // Check likes for each post
//         data.forEach(post => {
//           checkUserLike(post.postId);
//         });
//       } else {
//         throw new Error('Failed to fetch posts');
//       }
//     } catch (error) {
//       console.error('Error fetching posts:', error);
//     }
//   };

//   // Fetch member requests for my communities
//   const fetchMemberRequests = async () => {
//     if (!currentUserId) return;

//     try {
//       const requests = [];
//       for (const community of myCommunities) {
//         const response = await fetch(`${apiUrl}/communitymaster/member/requests/${community.communityId}`);
//         if (response.ok) {
//           const data = await response.json();
//           requests.push(...data.map(req => ({ ...req, communityName: community.communityName })));
//         }
//       }
//       setMemberRequests(requests);
//     } catch (error) {
//       console.error('Error fetching member requests:', error);
//     }
//   };

//   // Check if user has liked a post
//   const checkUserLike = async (postId) => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/like/check/${postId}/${currentUserId}`);
//       if (response.ok) {
//         const hasLiked = await response.json();
//         setUserLikes(prev => ({ ...prev, [postId]: hasLiked }));
//       }
//     } catch (error) {
//       console.error('Error checking like:', error);
//     }
//   };

//   // Check if user is member of community
//   const checkMembership = async (communityId) => {
//     if (!currentUserId || !communityId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/check/${communityId}/${currentUserId}`);
//       if (response.ok) {
//         const isMember = await response.json();
//         setIsMember(isMember);
//       }
//     } catch (error) {
//       console.error('Error checking membership:', error);
//     }
//   };

//   // Get user community status (pending, approved, not_joined)
//   const fetchCommunityStatus = async (communityId) => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/status/${communityId}/${currentUserId}`);
//       if (response.ok) {
//         const status = await response.json();
//         setCommunityStatus(prev => ({ ...prev, [communityId]: status }));
//       }
//     } catch (error) {
//       console.error('Error fetching community status:', error);
//     }
//   };

//   // Create new community with profile picture
//   const handleCreateCommunity = async () => {
//     if (!newCommunity.communityName.trim() || !newCommunity.description.trim() || !newCommunity.category.trim()) {
//       showSnackbar('Please fill all required fields', 'error');
//       return;
//     }

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append('communityName', newCommunity.communityName);
//       formData.append('description', newCommunity.description);
//       formData.append('category', newCommunity.category);
//       formData.append('type', newCommunity.type);
//       formData.append('userId', newCommunity.userId);
//       formData.append('createdBy', newCommunity.createdBy);

//       if (newCommunity.profilePicture instanceof File) {
//         formData.append('profilePicture', newCommunity.profilePicture);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         const result = await response.json();
//         showSnackbar('Community created successfully! Waiting for admin approval.', 'success');
//         setCreateDialogOpen(false);
//         setNewCommunity({
//           communityName: '',
//           description: '',
//           type: 'public',
//           category: '',
//           userId: currentUserId,
//           createdBy: currentUserName,
//           profilePicture: null
//         });
//         setProfileImagePreview(null);

//         // Refresh communities list
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to create community');
//       }
//     } catch (error) {
//       console.error('Error creating community:', error);
//       showSnackbar(error.message || 'Error creating community', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle profile picture upload
//   const handleProfilePictureChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewCommunity({ ...newCommunity, profilePicture: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Join community
//   const handleJoinCommunity = async (community) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to join communities', 'warning');
//       return;
//     }

//     try {
//       const memberRequest = {
//         communityId: community.communityId,
//         userId: currentUserId,
//         status: 'pending',
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/member/request`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(memberRequest),
//       });

//       if (response.ok) {
//         // Create notification for community owner
//         const notification = {
//           communityId: community.communityId,
//           fromUserId: currentUserId,
//           toUserId: community.userId,
//           type: 'join_request',
//           message: `${currentUserName} wants to join your community "${community.communityName}"`,
//           fromUserName: currentUserName,
//           communityName: community.communityName
//         };

//         await fetch(`${apiUrl}/communitymaster/notification`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(notification),
//         });

//         showSnackbar('Join request sent! The community owner will review your request.', 'success');
//         fetchCommunityStatus(community.communityId);
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to send join request');
//       }
//     } catch (error) {
//       console.error('Error joining community:', error);
//       showSnackbar(error.message || 'Error sending join request', 'error');
//     }
//   };

//   // Approve member request
//   const handleApproveMember = async (memberId, communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/approve/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request approved!', 'success');
//         fetchMemberRequests();
//         fetchNotifications();
//         fetchAllCommunities();

//         // Refresh community status
//         if (selectedCommunity) {
//           checkMembership(selectedCommunity.communityId);
//         }
//       } else {
//         throw new Error('Failed to approve member');
//       }
//     } catch (error) {
//       console.error('Error approving member:', error);
//       showSnackbar('Error approving member', 'error');
//     }
//   };

//   // Reject member request
//   const handleRejectMember = async (memberId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/reject/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request rejected!', 'success');
//         fetchMemberRequests();
//       } else {
//         throw new Error('Failed to reject member');
//       }
//     } catch (error) {
//       console.error('Error rejecting member:', error);
//       showSnackbar('Error rejecting member', 'error');
//     }
//   };

//   // Delete notification
//   const handleDeleteNotification = async (notificationId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/notification/${notificationId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Notification deleted', 'success');
//         fetchNotifications();
//       } else {
//         throw new Error('Failed to delete notification');
//       }
//     } catch (error) {
//       console.error('Error deleting notification:', error);
//       showSnackbar('Error deleting notification', 'error');
//     }
//   };

//   // Fetch community members
//   const fetchCommunityMembers = async (communityId) => {
//     setLoadingMembers(true);
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/members/details/${communityId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setSelectedMembers(data);
//         setCommunityMembers(prev => ({ ...prev, [communityId]: data }));
//         setMembersDialogOpen(true);
//       } else {
//         throw new Error('Failed to fetch members');
//       }
//     } catch (error) {
//       console.error('Error fetching members:', error);
//       showSnackbar('Error fetching members', 'error');
//     } finally {
//       setLoadingMembers(false);
//     }
//   };

//   // Fetch post likes
//   const fetchPostLikes = async (postId) => {
//     setLoadingLikes(true);
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/likes/details/${postId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setSelectedLikes(data);
//         setLikesDialogOpen(true);
//       } else {
//         throw new Error('Failed to fetch likes');
//       }
//     } catch (error) {
//       console.error('Error fetching likes:', error);
//       showSnackbar('Error fetching likes', 'error');
//     } finally {
//       setLoadingLikes(false);
//     }
//   };

//   // Create post with image
//   const handleCreatePost = async (communityId) => {
//     if (!newPost.content.trim() && !newPost.imageFile) {
//       showSnackbar('Please add content or an image', 'warning');
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('communityId', communityId);
//       formData.append('userId', currentUserId);
//       formData.append('content', newPost.content);
//       formData.append('userName', currentUserName);

//       if (newPost.imageFile) {
//         formData.append('image', newPost.imageFile);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster/post`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         showSnackbar('Post created successfully!', 'success');
//         setNewPost({ content: '', imageFile: null, imagePreview: null });
//         fetchCommunityPosts(communityId);
//       } else {
//         throw new Error('Failed to create post');
//       }
//     } catch (error) {
//       console.error('Error creating post:', error);
//       showSnackbar('Error creating post', 'error');
//     }
//   };

//   // Handle post image upload
//   const handlePostImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewPost({ ...newPost, imageFile: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setNewPost(prev => ({ ...prev, imagePreview: reader.result }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Like post
//   const handleLikePost = async (postId) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to like posts', 'warning');
//       return;
//     }

//     try {
//       const likeData = {
//         postId: postId,
//         userId: currentUserId,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/like`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(likeData),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         fetchCommunityPosts(selectedCommunity.communityId);
//         checkUserLike(postId);
//       } else {
//         throw new Error('Failed to like post');
//       }
//     } catch (error) {
//       console.error('Error liking post:', error);
//       showSnackbar('Error liking post', 'error');
//     }
//   };

//   // Add comment
//   const handleAddComment = async (postId) => {
//     if (!comment.trim()) return;

//     try {
//       const commentData = {
//         postId: postId,
//         userId: currentUserId,
//         content: comment,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/comment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(commentData),
//       });

//       if (response.ok) {
//         showSnackbar('Comment added!', 'success');
//         setComment('');
//         fetchPostComments(postId);
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to add comment');
//       }
//     } catch (error) {
//       console.error('Error adding comment:', error);
//       showSnackbar('Error adding comment', 'error');
//     }
//   };

//   // Fetch post comments
//   const fetchPostComments = async (postId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/comments/${postId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setPostComments(prev => ({ ...prev, [postId]: data }));
//       }
//     } catch (error) {
//       console.error('Error fetching comments:', error);
//     }
//   };

//   // Delete community
//   const handleDeleteCommunity = async (communityId) => {
//     if (!window.confirm('Are you sure you want to delete this community?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/${communityId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Community deleted successfully!', 'success');
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         throw new Error('Failed to delete community');
//       }
//     } catch (error) {
//       console.error('Error deleting community:', error);
//       showSnackbar('Error deleting community', 'error');
//     }
//   };

//   // Delete post
//   const handleDeletePost = async (postId) => {
//     if (!window.confirm('Are you sure you want to delete this post?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/post/${postId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Post deleted successfully!', 'success');
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to delete post');
//       }
//     } catch (error) {
//       console.error('Error deleting post:', error);
//       showSnackbar('Error deleting post', 'error');
//     }
//   };

//   // Snackbar utility
//   const showSnackbar = (message, severity) => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Check if user owns the community
//   const isCommunityOwner = (community) => {
//     return community.userId === currentUserId;
//   };

//   // Get community status text
//   const getCommunityStatusText = (communityId) => {
//     const status = communityStatus[communityId];
//     if (!status) return 'Join Community';

//     switch (status) {
//       case 'pending': return 'Request Pending';
//       case 'approved': return 'Joined';
//       case 'rejected': return 'Join Community';
//       default: return 'Join Community';
//     }
//   };

//   // Get community status color
//   const getCommunityStatusColor = (communityId) => {
//     const status = communityStatus[communityId];
//     if (status === 'approved') return 'success';
//     if (status === 'pending') return 'warning';
//     return 'secondary';
//   };

//   // Initialize data
//   useEffect(() => {
//     fetchAllCommunities();
//     if (currentUserId) {
//       fetchMyCommunities();
//       fetchNotifications();
//     }
//   }, [currentUserId]);

//   useEffect(() => {
//     if (myCommunities.length > 0) {
//       fetchMemberRequests();
//     }
//   }, [myCommunities]);

//   useEffect(() => {
//     if (selectedCommunity) {
//       fetchCommunityPosts(selectedCommunity.communityId);
//       checkMembership(selectedCommunity.communityId);
//       fetchCommunityStatus(selectedCommunity.communityId);
//     }
//   }, [selectedCommunity, currentUserId]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString();
//   };

//   const formatJoinDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString();
//   };

//   const formatLikeDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString();
//   };

//   return (
//     <div className={classes.root}>
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Box className={classes.header}>
//           <Typography variant="h3" gutterBottom>
//             Community Hub
//           </Typography>
//           <Typography variant="h6">
//             Connect, share, and grow with like-minded individuals
//           </Typography>
//           <Button
//             variant="contained"
//             className={classes.createButton}
//             startIcon={<Add />}
//             onClick={() => {
//               if (!currentUserId) {
//                 history.push('/login');
//               } else {
//                 setCreateDialogOpen(true);
//               }
//             }}
//             sx={{ mt: 2 }}
//           >
//             {currentUserId ? 'Create Community' : 'Login to Create Community'}
//           </Button>
//           {!currentUserId && (
//             <Typography variant="body2" sx={{ mt: 1 }}>
//               Please login to create and join communities
//             </Typography>
//           )}
//         </Box>

//         {/* Tabs */}
//         <div style={{ position: 'relative', marginBottom: '100px' }}>
//           <AppBar
//             sx={{
//               borderRadius: 2,
//               position: 'absolute !important',
//             }}
//             color="default"
//           >
//             <Tabs
//               value={tabValue}
//               onChange={handleTabChange}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="fullWidth"
//             >
//               <Tab label="All Communities" icon={<Public />} />
//               <Tab label="My Communities" icon={<Group />} />
//               <Tab
//                 label={
//                   <Badge badgeContent={notifications.length + memberRequests.length} color="error">
//                     Notifications
//                   </Badge>
//                 }
//                 icon={<Notifications />}
//               />
//             </Tabs>
//           </AppBar>
//         </div>

//         {/* All Communities Tab */}
//         <TabPanel value={tabValue} index={0}>
//           {loading ? (
//             <Box display="flex" justifyContent="center" py={4}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <Grid container spacing={3}>
//               {communities.map((community) => (
//                 <Grid item xs={12} sm={6} md={4} key={community.communityId || community._id}>
//                   <Card className={classes.communityCard}>
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Box display="flex" alignItems="center" mb={2}>
//                         <Avatar
//                           sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                           src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                         >
//                           {!community.profilePicture && <Group />}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" gutterBottom>
//                             {community.communityName}
//                           </Typography>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Chip
//                               label={community.type || 'public'}
//                               size="small"
//                               color={community.type === 'public' ? 'primary' : 'secondary'}
//                             />
//                             {isCommunityOwner(community) && (
//                               <Chip
//                                 label="Owner"
//                                 size="small"
//                                 color="success"
//                               />
//                             )}
//                           </Box>
//                         </Box>
//                       </Box>
//                       <Typography variant="body2" color="text.secondary" paragraph>
//                         {community.description}
//                       </Typography>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="text.secondary">
//                           <People sx={{ fontSize: 16, mr: 0.5 }} />
//                           <span
//                             className={classes.clickableCount}
//                             onClick={() => fetchCommunityMembers(community.communityId)}
//                           >
//                             {community.members || 1} members
//                           </span>
//                         </Typography>
//                         <Chip label={community.category} variant="outlined" size="small" />
//                       </Box>
//                     </CardContent>
//                     <CardActions>
//                       <Button
//                         size="small"
//                         color="primary"
//                         onClick={() => setSelectedCommunity(community)}
//                       >
//                         View Details
//                       </Button>
//                       {!isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color={getCommunityStatusColor(community.communityId)}
//                           variant={communityStatus[community.communityId] === 'approved' ? "contained" : "outlined"}
//                           onClick={() => {
//                             if (communityStatus[community.communityId] === 'approved') {
//                               // Already joined, do nothing
//                             } else if (communityStatus[community.communityId] === 'pending') {
//                               // Request pending, do nothing
//                             } else {
//                               handleJoinCommunity(community);
//                             }
//                           }}
//                           disabled={!currentUserId || communityStatus[community.communityId] === 'pending' || communityStatus[community.communityId] === 'approved'}
//                           startIcon={
//                             communityStatus[community.communityId] === 'approved' ?
//                               <CheckCircleOutline /> :
//                               communityStatus[community.communityId] === 'pending' ?
//                                 <CircularProgress size={16} /> :
//                                 <PersonAdd />
//                           }
//                         >
//                           {getCommunityStatusText(community.communityId)}
//                         </Button>
//                       )}
//                       {isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="error"
//                           onClick={() => handleDeleteCommunity(community.communityId)}
//                         >
//                           Delete
//                         </Button>
//                       )}
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))}
//               {communities.length === 0 && (
//                 <Grid item xs={12}>
//                   <Typography variant="h6" textAlign="center" color="text.secondary">
//                     No approved communities found. Create one or wait for admin approval.
//                   </Typography>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </TabPanel>

//         {/* My Communities Tab */}
//         <TabPanel value={tabValue} index={1}>
//           {!currentUserId ? (
//             <Typography variant="h6" textAlign="center" color="text.secondary">
//               Please login to view your communities
//             </Typography>
//           ) : loading ? (
//             <Box display="flex" justifyContent="center" py={4}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               <Typography variant="h5" gutterBottom>
//                 Communities You've Created
//               </Typography>
//               <Grid container spacing={3}>
//                 {myCommunities.map((community) => (
//                   <Grid item xs={12} key={community.communityId || community._id}>
//                     <Card className={classes.communityCard}>
//                       <CardContent>
//                         <Box display="flex" alignItems="center" mb={3}>
//                           <Avatar
//                             sx={{ bgcolor: '#667eea', mr: 2, width: 60, height: 60 }}
//                             src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                           >
//                             {!community.profilePicture && <Group />}
//                           </Avatar>
//                           <Box flexGrow={1}>
//                             <Typography variant="h6" gutterBottom>
//                               {community.communityName}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                               {community.description}
//                             </Typography>
//                           </Box>
//                           <Box display="flex" alignItems="center" gap={2}>
//                             <Chip
//                               label={`${community.members || 1} members`}
//                               color="primary"
//                               variant="outlined"
//                               onClick={() => fetchCommunityMembers(community.communityId)}
//                               sx={{ cursor: 'pointer' }}
//                             />
//                           </Box>
//                         </Box>

//                         {/* Create Post Section */}
//                         <Box mb={3}>
//                           <TextField
//                             fullWidth
//                             variant="outlined"
//                             placeholder="Share something with the community..."
//                             value={newPost.content}
//                             onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                             multiline
//                             rows={2}
//                           />

//                           {/* Image upload for post */}
//                           <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <input
//                               accept="image/*"
//                               className={classes.fileInput}
//                               id="post-image-upload"
//                               type="file"
//                               onChange={handlePostImageChange}
//                             />
//                             <label htmlFor="post-image-upload">
//                               <IconButton color="primary" component="span">
//                                 <AddPhotoAlternate />
//                               </IconButton>
//                             </label>
//                             {newPost.imagePreview && (
//                               <>
//                                 <Typography variant="caption">
//                                   Image selected
//                                 </Typography>
//                                 <IconButton
//                                   size="small"
//                                   onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                                 >
//                                   <Cancel fontSize="small" />
//                                 </IconButton>
//                               </>
//                             )}
//                           </Box>

//                           {/* Image preview */}
//                           {newPost.imagePreview && (
//                             <Box sx={{ mt: 1 }}>
//                               <img
//                                 src={newPost.imagePreview}
//                                 alt="Preview"
//                                 className={classes.imagePreview}
//                               />
//                             </Box>
//                           )}

//                           <Box mt={1} display="flex" justifyContent="flex-end">
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               onClick={() => handleCreatePost(community.communityId)}
//                               disabled={(!newPost.content.trim() && !newPost.imageFile)}
//                             >
//                               Post
//                             </Button>
//                           </Box>
//                         </Box>

//                         {/* View Community Button */}
//                         <Box mt={2}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() => setSelectedCommunity(community)}
//                           >
//                             View Community Posts
//                           </Button>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//                 {myCommunities.length === 0 && (
//                   <Grid item xs={12}>
//                     <Typography variant="h6" textAlign="center" color="text.secondary">
//                       You haven't created any communities yet or your communities are pending approval.
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </>
//           )}
//         </TabPanel>

//         {/* Notifications Tab */}
//         <TabPanel value={tabValue} index={2}>
//           <Typography variant="h5" gutterBottom>
//             Notifications
//           </Typography>

//           {/* Member Requests */}
//           {memberRequests.length > 0 && (
//             <Box mb={4}>
//               <Typography variant="h6" gutterBottom>
//                 Member Requests ({memberRequests.length})
//               </Typography>
//               <List>
//                 {memberRequests.map((request) => (
//                   <ListItem
//                     key={request.memberId}
//                     className={classes.notificationItem}
//                     component={Paper}
//                     elevation={1}
//                     sx={{ mb: 2, p: 2 }}
//                   >
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         <Group />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={`Join request from ${request.userName}`}
//                       secondary={
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             {request.communityName} • {formatDate(request.createdAt)}
//                           </Typography>
//                           <Box mt={1} display="flex" gap={1}>
//                             <Button
//                               size="small"
//                               variant="contained"
//                               color="primary"
//                               startIcon={<CheckCircle />}
//                               onClick={() => handleApproveMember(request.memberId, request.communityId)}
//                             >
//                               Approve
//                             </Button>
//                             <Button
//                               size="small"
//                               variant="outlined"
//                               color="secondary"
//                               startIcon={<Cancel />}
//                               onClick={() => handleRejectMember(request.memberId)}
//                             >
//                               Decline
//                             </Button>
//                           </Box>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}

//           {/* Other Notifications */}
//           <List>
//             {notifications.map((notification) => (
//               <ListItem
//                 key={notification.notificationId}
//                 className={classes.notificationItem}
//                 component={Paper}
//                 elevation={1}
//                 sx={{ mb: 2, p: 2 }}
//               >
//                 <ListItemAvatar>
//                   <Avatar sx={{ bgcolor: '#667eea' }}>
//                     <Notifications />
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={notification.message}
//                   secondary={
//                     <Typography variant="body2" color="text.secondary">
//                       {notification.communityName} • {formatDate(notification.createdAt)}
//                     </Typography>
//                   }
//                 />
//                 <IconButton
//                   size="small"
//                   color="error"
//                   onClick={() => handleDeleteNotification(notification.notificationId)}
//                   title="Delete Notification"
//                 >
//                   <Close fontSize="small" />
//                 </IconButton>
//               </ListItem>
//             ))}
//             {notifications.length === 0 && memberRequests.length === 0 && (
//               <Typography variant="body2" color="text.secondary" textAlign="center">
//                 No notifications yet.
//               </Typography>
//             )}
//           </List>
//         </TabPanel>

//         {/* Community Details Dialog with Posts */}
//         <Dialog
//           open={!!selectedCommunity}
//           onClose={() => setSelectedCommunity(null)}
//           maxWidth="md"
//           fullWidth
//           scroll="paper"
//         >
//           {selectedCommunity && (
//             <>
//               <DialogTitle>
//                 <Box display="flex" alignItems="center">
//                   <Avatar
//                     sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                     src={selectedCommunity.profilePicture ? `${apiUrl}${selectedCommunity.profilePicture}` : undefined}
//                   >
//                     {!selectedCommunity.profilePicture && <Group />}
//                   </Avatar>
//                   <Box>
//                     <Typography variant="h6">{selectedCommunity.communityName}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {selectedCommunity.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </DialogTitle>
//               <DialogContent>
//                 <Box display="flex" gap={2} mb={2} flexWrap="wrap">
//                   <Chip
//                     label={`${selectedCommunity.members || 1} members`}
//                     onClick={() => fetchCommunityMembers(selectedCommunity.communityId)}
//                     sx={{ cursor: 'pointer' }}
//                   />
//                   <Chip label={selectedCommunity.type || 'public'} color="primary" />
//                   <Chip label={selectedCommunity.category} variant="outlined" />
//                   {isCommunityOwner(selectedCommunity) && (
//                     <Chip label="You are the owner" color="success" />
//                   )}
//                   {isMember && !isCommunityOwner(selectedCommunity) && (
//                     <Chip label="Member" color="primary" variant="outlined" />
//                   )}
//                 </Box>

//                 {/* Create Post (for members and owner) */}
//                 {(isCommunityOwner(selectedCommunity) || isMember) && (
//                   <Box mb={3}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       placeholder="Share something with the community..."
//                       value={newPost.content}
//                       onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                       multiline
//                       rows={2}
//                     />

//                     {/* Image upload for post */}
//                     <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <input
//                         accept="image/*"
//                         className={classes.fileInput}
//                         id="community-post-image-upload"
//                         type="file"
//                         onChange={handlePostImageChange}
//                       />
//                       <label htmlFor="community-post-image-upload">
//                         <IconButton color="primary" component="span">
//                           <AddPhotoAlternate />
//                         </IconButton>
//                       </label>
//                       {newPost.imagePreview && (
//                         <>
//                           <Typography variant="caption">
//                             Image selected
//                           </Typography>
//                           <IconButton
//                             size="small"
//                             onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                           >
//                             <Cancel fontSize="small" />
//                           </IconButton>
//                         </>
//                       )}
//                     </Box>

//                     {/* Image preview */}
//                     {newPost.imagePreview && (
//                       <Box sx={{ mt: 1 }}>
//                         <img
//                           src={newPost.imagePreview}
//                           alt="Preview"
//                           className={classes.imagePreview}
//                         />
//                       </Box>
//                     )}

//                     <Box mt={1} display="flex" justifyContent="flex-end">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => handleCreatePost(selectedCommunity.communityId)}
//                         disabled={!newPost.content.trim() && !newPost.imageFile}
//                       >
//                         Post
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Posts */}
//                 <Typography variant="h6" gutterBottom>
//                   Community Posts
//                 </Typography>
//                 {communityPosts.length > 0 ? (
//                   communityPosts.map((post) => (
//                     <Paper key={post.postId} className={classes.postCard} elevation={1}>
//                       {/* Post Header */}
//                       <Box className={classes.postHeader}>
//                         <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                           {post.userName?.charAt(0) || 'U'}
//                         </Avatar>
//                         <Box flexGrow={1}>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {post.userName}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {formatDate(post.createdAt)}
//                           </Typography>
//                         </Box>
//                         {isCommunityOwner(selectedCommunity) && (
//                           <Tooltip title="Delete Post">
//                             <IconButton
//                               size="small"
//                               color="error"
//                               onClick={() => handleDeletePost(post.postId)}
//                             >
//                               <Delete fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Box>

//                       {/* Post Content */}
//                       <CardContent>
//                         {post.content && (
//                           <Typography variant="body1" paragraph>
//                             {post.content}
//                           </Typography>
//                         )}
//                         {post.imageUrl && (
//                           <Box sx={{ mt: 2 }}>
//                             <img
//                               src={`${apiUrl}${post.imageUrl}`}
//                               alt="Post"
//                               className={classes.imagePreview}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
//                               }}
//                             />
//                           </Box>
//                         )}
//                       </CardContent>

//                       {/* Action Buttons */}
//                       <Box className={classes.actionButtons}>
//                         <Box display="flex" alignItems="center">
//                           <IconButton
//                             onClick={() => handleLikePost(post.postId)}
//                             color={userLikes[post.postId] ? 'error' : 'default'}
//                           >
//                             {userLikes[post.postId] ? <Favorite /> : <FavoriteBorder />}
//                           </IconButton>
//                           <Typography
//                             variant="body2"
//                             sx={{ ml: 1, cursor: 'pointer' }}
//                             className={classes.clickableCount}
//                             onClick={() => fetchPostLikes(post.postId)}
//                           >
//                             {post.likes || 0} likes
//                           </Typography>
//                         </Box>
//                         <Box display="flex" alignItems="center">
//                           <IconButton onClick={() => fetchPostComments(post.postId)}>
//                             <Comment fontSize="small" />
//                           </IconButton>
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.comments || 0} comments
//                           </Typography>
//                         </Box>
//                         <IconButton>
//                           <Share fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.shares || 0}
//                           </Typography>
//                         </IconButton>
//                       </Box>

//                       {/* Comments Section */}
//                       {postComments[post.postId] && (
//                         <Box className={classes.commentSection}>
//                           <Typography variant="subtitle2" gutterBottom>
//                             Comments:
//                           </Typography>
//                           {postComments[post.postId].map((commentItem) => (
//                             <Box key={commentItem.commentId} mb={1}>
//                               <Typography variant="body2" fontWeight="bold">
//                                 {commentItem.userName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 {commentItem.content}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {formatDate(commentItem.createdAt)}
//                               </Typography>
//                               <Divider sx={{ mt: 1 }} />
//                             </Box>
//                           ))}

//                           {/* Add Comment */}
//                           <Box mt={2} display="flex">
//                             <TextField
//                               fullWidth
//                               size="small"
//                               placeholder="Write a comment..."
//                               value={comment}
//                               onChange={(e) => setComment(e.target.value)}
//                               InputProps={{
//                                 endAdornment: (
//                                   <InputAdornment position="end">
//                                     <IconButton
//                                       color="primary"
//                                       onClick={() => handleAddComment(post.postId)}
//                                       disabled={!comment.trim()}
//                                     >
//                                       <Send />
//                                     </IconButton>
//                                   </InputAdornment>
//                                 ),
//                               }}
//                             />
//                           </Box>
//                         </Box>
//                       )}
//                     </Paper>
//                   ))
//                 ) : (
//                   <Typography color="text.secondary" textAlign="center">
//                     No posts yet. Be the first to post!
//                   </Typography>
//                 )}
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setSelectedCommunity(null)}>Close</Button>
//               </DialogActions>
//             </>
//           )}
//         </Dialog>

//         {/* Create Community Dialog */}
//         <Dialog
//           open={createDialogOpen}
//           onClose={() => setCreateDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>Create New Community</DialogTitle>
//           <DialogContent>
//             <Box component="form" sx={{ mt: 2 }}>
//               <TextField
//                 autoFocus
//                 margin="dense"
//                 label="Community Name *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.communityName}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, communityName: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Description *"
//                 fullWidth
//                 variant="outlined"
//                 multiline
//                 rows={3}
//                 value={newCommunity.description}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, description: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Category *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.category}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, category: e.target.value })}
//                 required
//               />

//               {/* Profile Picture Upload */}
//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <input
//                   accept="image/*"
//                   className={classes.fileInput}
//                   id="profile-picture-upload"
//                   type="file"
//                   onChange={handleProfilePictureChange}
//                 />
//                 <label htmlFor="profile-picture-upload">
//                   <Button variant="outlined" component="span" startIcon={<AddPhotoAlternate />}>
//                     Upload Profile Picture
//                   </Button>
//                 </label>
//                 {profileImagePreview && (
//                   <Box sx={{ mt: 2 }}>
//                     <Typography variant="caption">Preview:</Typography>
//                     <img
//                       src={profileImagePreview}
//                       alt="Profile Preview"
//                       style={{
//                         width: '100px',
//                         height: '100px',
//                         objectFit: 'cover',
//                         borderRadius: '8px',
//                         marginTop: '8px',
//                         border: '1px solid #dee2e6'
//                       }}
//                     />
//                   </Box>
//                 )}
//                 <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
//                   Optional: Upload a profile picture for your community (JPEG, PNG, WEBP, max 5MB)
//                 </Typography>
//               </Box>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setCreateDialogOpen(false)}>Cancel</Button>
//             <Button
//               onClick={handleCreateCommunity}
//               variant="contained"
//               color="primary"
//               disabled={!newCommunity.communityName.trim() ||
//                 !newCommunity.description.trim() ||
//                 !newCommunity.category.trim() ||
//                 loading}
//             >
//               {loading ? 'Creating...' : 'Create Community'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Members Dialog */}
//         <Dialog
//           open={membersDialogOpen}
//           onClose={() => setMembersDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             Members
//             {selectedCommunity && ` of "${selectedCommunity.communityName}"`}
//           </DialogTitle>
//           <DialogContent>
//             {loadingMembers ? (
//               <Box display="flex" justifyContent="center" py={4}>
//                 <CircularProgress />
//               </Box>
//             ) : selectedMembers.length > 0 ? (
//               <List>
//                 {selectedMembers.map((member) => (
//                   <ListItem key={member.memberId}>
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         {member.userName?.charAt(0) || 'U'}
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={member.userName}
//                       secondary={
//                         <Box>
//                           <Typography variant="caption">
//                             User ID: {member.userId}
//                           </Typography>
//                           <br />
//                           <Typography variant="caption">
//                             Joined: {formatJoinDate(member.joinedAt)}
//                           </Typography>
//                         </Box>
//                       }
//                     />
//                     {member.status === 'approved' && (
//                       <Chip
//                         label="Member"
//                         color="success"
//                         size="small"
//                       />
//                     )}
//                   </ListItem>
//                 ))}
//               </List>
//             ) : (
//               <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
//                 No members found.
//               </Typography>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setMembersDialogOpen(false)}>Close</Button>
//           </DialogActions>
//         </Dialog>

//         {/* Likes Dialog */}
//         <Dialog
//           open={likesDialogOpen}
//           onClose={() => setLikesDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>People who liked this post</DialogTitle>
//           <DialogContent>
//             {loadingLikes ? (
//               <Box display="flex" justifyContent="center" py={4}>
//                 <CircularProgress />
//               </Box>
//             ) : selectedLikes.length > 0 ? (
//               <List>
//                 {selectedLikes.map((like) => (
//                   <ListItem key={like.likeId}>
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         {like.userName?.charAt(0) || 'U'}
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={like.userName}
//                       secondary={
//                         <Typography variant="caption">
//                           Liked: {formatLikeDate(like.likedAt)}
//                         </Typography>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             ) : (
//               <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
//                 No likes yet.
//               </Typography>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setLikesDialogOpen(false)}>Close</Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Container>
//     </div>
//   );
// };

// export default Community;



// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   AppBar,
//   Tabs,
//   Tab,
//   Chip,
//   Avatar,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Badge,
//   Divider,
//   Paper,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Tooltip
// } from '@mui/material';
// import {
//   ThumbUp,
//   Comment,
//   Share,
//   Group,
//   Add,
//   Notifications,
//   Public,
//   Lock,
//   People,
//   Send,
//   Favorite,
//   FavoriteBorder,
//   AddPhotoAlternate,
//   Delete,
//   CheckCircle,
//   Cancel
// } from '@mui/icons-material';
// import { useHistory } from 'react-router-dom';
// import { makeStyles } from '@material-ui/core/styles';
// import { apiUrl } from '../coreservices/environment';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: '#f8f9fa',
//     minHeight: '100vh',
//     paddingTop: theme.spacing(4),
//   },
//   header: {
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     color: 'white',
//     padding: theme.spacing(4),
//     borderRadius: theme.spacing(2),
//     marginBottom: theme.spacing(4),
//   },
//   communityCard: {
//     transition: 'transform 0.2s, box-shadow 0.2s',
//     '&:hover': {
//       transform: 'translateY(-4px)',
//       boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
//     },
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   createButton: {
//     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
//     color: 'white',
//     fontWeight: 'bold',
//     padding: '12px 30px',
//     borderRadius: '25px',
//     '&:hover': {
//       transform: 'scale(1.05)',
//     },
//   },
//   tabPanel: {
//     padding: theme.spacing(3, 0),
//   },
//   postCard: {
//     marginBottom: theme.spacing(3),
//     borderRadius: '12px',
//     overflow: 'hidden',
//   },
//   postHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     borderBottom: '1px solid #e0e0e0',
//   },
//   actionButtons: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     padding: theme.spacing(1, 2),
//   },
//   commentSection: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fafafa',
//   },
//   notificationItem: {
//     borderLeft: '4px solid #667eea',
//     marginBottom: theme.spacing(1),
//   },
//   imagePreview: {
//     maxWidth: '100%',
//     maxHeight: '400px',
//     borderRadius: '8px',
//     marginTop: theme.spacing(2),
//     objectFit: 'contain',
//   },
//   fileInput: {
//     display: 'none',
//   },
// }));

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`community-tabpanel-${index}`}
//       aria-labelledby={`community-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// const Community = () => {
//   const classes = useStyles();
//   const history = useHistory();
//   const [tabValue, setTabValue] = useState(0);
//   const [createDialogOpen, setCreateDialogOpen] = useState(false);
//   const [selectedCommunity, setSelectedCommunity] = useState(null);
//   const [communityPosts, setCommunityPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Get current user data from localStorage
//   const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//   const currentUserId = userData?.userId;
//   const currentUserName = userData?.firstName || 'User';

//   const [newCommunity, setNewCommunity] = useState({
//     communityName: '',
//     description: '',
//     type: 'public',
//     category: '',
//     userId: currentUserId,
//     createdBy: currentUserName,
//     profilePicture: null
//   });

//   const [newPost, setNewPost] = useState({
//     content: '',
//     imageFile: null,
//     imagePreview: null
//   });
//   const [comment, setComment] = useState('');
//   const [postComments, setPostComments] = useState({});

//   // State for dynamic data from API
//   const [communities, setCommunities] = useState([]);
//   const [myCommunities, setMyCommunities] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [memberRequests, setMemberRequests] = useState([]);
//   const [userLikes, setUserLikes] = useState({});
//   const [isMember, setIsMember] = useState(false);
//   const [profileImagePreview, setProfileImagePreview] = useState(null);

//   // Fetch all approved communities
//   const fetchAllCommunities = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${apiUrl}/communitymaster`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunities(data);
//       } else {
//         throw new Error('Failed to fetch communities');
//       }
//     } catch (error) {
//       console.error('Error fetching communities:', error);
//       showSnackbar('Error fetching communities', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch my approved communities
//   const fetchMyCommunities = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/mycommunities/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setMyCommunities(data);
//       } else {
//         throw new Error('Failed to fetch my communities');
//       }
//     } catch (error) {
//       console.error('Error fetching my communities:', error);
//       showSnackbar('Error fetching your communities', 'error');
//     }
//   };

//   // Fetch notifications (filter out inactive)
//   const fetchNotifications = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/notifications/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setNotifications(data.filter(notification => notification.isActive));
//       } else {
//         throw new Error('Failed to fetch notifications');
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//     }
//   };

//   // Fetch community posts
//   const fetchCommunityPosts = async (communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/posts/${communityId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunityPosts(data);

//         // Check likes for each post
//         data.forEach(post => {
//           checkUserLike(post.postId);
//         });
//       } else {
//         throw new Error('Failed to fetch posts');
//       }
//     } catch (error) {
//       console.error('Error fetching posts:', error);
//     }
//   };

//   // Fetch member requests for my communities
//   const fetchMemberRequests = async () => {
//     if (!currentUserId) return;

//     try {
//       const requests = [];
//       for (const community of myCommunities) {
//         const response = await fetch(`${apiUrl}/communitymaster/member/requests/${community.communityId}`);
//         if (response.ok) {
//           const data = await response.json();
//           requests.push(...data.map(req => ({ ...req, communityName: community.communityName })));
//         }
//       }
//       setMemberRequests(requests);
//     } catch (error) {
//       console.error('Error fetching member requests:', error);
//     }
//   };

//   // Check if user has liked a post
//   const checkUserLike = async (postId) => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/like/check/${postId}/${currentUserId}`);
//       if (response.ok) {
//         const hasLiked = await response.json();
//         setUserLikes(prev => ({ ...prev, [postId]: hasLiked }));
//       }
//     } catch (error) {
//       console.error('Error checking like:', error);
//     }
//   };

//   // Check if user is member of community
//   const checkMembership = async (communityId) => {
//     if (!currentUserId || !communityId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/check/${communityId}/${currentUserId}`);
//       if (response.ok) {
//         const isMember = await response.json();
//         setIsMember(isMember);
//       }
//     } catch (error) {
//       console.error('Error checking membership:', error);
//     }
//   };

//   // Create new community with profile picture
//   const handleCreateCommunity = async () => {
//     if (!newCommunity.communityName.trim() || !newCommunity.description.trim() || !newCommunity.category.trim()) {
//       showSnackbar('Please fill all required fields', 'error');
//       return;
//     }

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append('communityName', newCommunity.communityName);
//       formData.append('description', newCommunity.description);
//       formData.append('category', newCommunity.category);
//       formData.append('type', newCommunity.type);
//       formData.append('userId', newCommunity.userId);
//       formData.append('createdBy', newCommunity.createdBy);

//       if (newCommunity.profilePicture instanceof File) {
//         formData.append('profilePicture', newCommunity.profilePicture);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         const result = await response.json();
//         showSnackbar('Community created successfully! Waiting for admin approval.', 'success');
//         setCreateDialogOpen(false);
//         setNewCommunity({
//           communityName: '',
//           description: '',
//           type: 'public',
//           category: '',
//           userId: currentUserId,
//           createdBy: currentUserName,
//           profilePicture: null
//         });
//         setProfileImagePreview(null);

//         // Refresh communities list
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to create community');
//       }
//     } catch (error) {
//       console.error('Error creating community:', error);
//       showSnackbar(error.message || 'Error creating community', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle profile picture upload
//   const handleProfilePictureChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewCommunity({ ...newCommunity, profilePicture: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Join community
//   const handleJoinCommunity = async (community) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to join communities', 'warning');
//       return;
//     }

//     try {
//       const memberRequest = {
//         communityId: community.communityId,
//         userId: currentUserId,
//         status: 'pending',
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/member/request`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(memberRequest),
//       });

//       if (response.ok) {
//         // Create notification for community owner
//         const notification = {
//           communityId: community.communityId,
//           fromUserId: currentUserId,
//           toUserId: community.userId,
//           type: 'join_request',
//           message: `${currentUserName} wants to join your community "${community.communityName}"`,
//           fromUserName: currentUserName,
//           communityName: community.communityName
//         };

//         await fetch(`${apiUrl}/communitymaster/notification`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(notification),
//         });

//         showSnackbar('Join request sent! The community owner will review your request.', 'success');
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to send join request');
//       }
//     } catch (error) {
//       console.error('Error joining community:', error);
//       showSnackbar(error.message || 'Error sending join request', 'error');
//     }
//   };

//   // Approve member request
//   const handleApproveMember = async (memberId, communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/approve/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request approved!', 'success');
//         fetchMemberRequests();
//         fetchNotifications(); // Refresh notifications
//         fetchAllCommunities();
//       } else {
//         throw new Error('Failed to approve member');
//       }
//     } catch (error) {
//       console.error('Error approving member:', error);
//       showSnackbar('Error approving member', 'error');
//     }
//   };

//   // Reject member request
//   const handleRejectMember = async (memberId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/reject/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request rejected!', 'success');
//         fetchMemberRequests();
//       } else {
//         throw new Error('Failed to reject member');
//       }
//     } catch (error) {
//       console.error('Error rejecting member:', error);
//       showSnackbar('Error rejecting member', 'error');
//     }
//   };

//   // Create post with image
//   const handleCreatePost = async (communityId) => {
//     if (!newPost.content.trim() && !newPost.imageFile) {
//       showSnackbar('Please add content or an image', 'warning');
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('communityId', communityId);
//       formData.append('userId', currentUserId);
//       formData.append('content', newPost.content);
//       formData.append('userName', currentUserName);

//       if (newPost.imageFile) {
//         formData.append('image', newPost.imageFile);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster/post`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         showSnackbar('Post created successfully!', 'success');
//         setNewPost({ content: '', imageFile: null, imagePreview: null });
//         fetchCommunityPosts(communityId);
//       } else {
//         throw new Error('Failed to create post');
//       }
//     } catch (error) {
//       console.error('Error creating post:', error);
//       showSnackbar('Error creating post', 'error');
//     }
//   };

//   // Handle post image upload
//   const handlePostImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewPost({ ...newPost, imageFile: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setNewPost(prev => ({ ...prev, imagePreview: reader.result }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Like post
//   const handleLikePost = async (postId) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to like posts', 'warning');
//       return;
//     }

//     try {
//       const likeData = {
//         postId: postId,
//         userId: currentUserId,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/like`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(likeData),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         fetchCommunityPosts(selectedCommunity.communityId);
//         checkUserLike(postId);
//       } else {
//         throw new Error('Failed to like post');
//       }
//     } catch (error) {
//       console.error('Error liking post:', error);
//       showSnackbar('Error liking post', 'error');
//     }
//   };

//   // Add comment
//   const handleAddComment = async (postId) => {
//     if (!comment.trim()) return;

//     try {
//       const commentData = {
//         postId: postId,
//         userId: currentUserId,
//         content: comment,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/comment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(commentData),
//       });

//       if (response.ok) {
//         showSnackbar('Comment added!', 'success');
//         setComment('');
//         fetchPostComments(postId);
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to add comment');
//       }
//     } catch (error) {
//       console.error('Error adding comment:', error);
//       showSnackbar('Error adding comment', 'error');
//     }
//   };

//   // Fetch post comments
//   const fetchPostComments = async (postId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/comments/${postId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setPostComments(prev => ({ ...prev, [postId]: data }));
//       }
//     } catch (error) {
//       console.error('Error fetching comments:', error);
//     }
//   };

//   // Delete community
//   const handleDeleteCommunity = async (communityId) => {
//     if (!window.confirm('Are you sure you want to delete this community?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/${communityId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Community deleted successfully!', 'success');
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         throw new Error('Failed to delete community');
//       }
//     } catch (error) {
//       console.error('Error deleting community:', error);
//       showSnackbar('Error deleting community', 'error');
//     }
//   };

//   // Delete post
//   const handleDeletePost = async (postId) => {
//     if (!window.confirm('Are you sure you want to delete this post?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/post/${postId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Post deleted successfully!', 'success');
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to delete post');
//       }
//     } catch (error) {
//       console.error('Error deleting post:', error);
//       showSnackbar('Error deleting post', 'error');
//     }
//   };

//   // Snackbar utility
//   const showSnackbar = (message, severity) => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Check if user owns the community
//   const isCommunityOwner = (community) => {
//     return community.userId === currentUserId;
//   };

//   // Initialize data
//   useEffect(() => {
//     fetchAllCommunities();
//     if (currentUserId) {
//       fetchMyCommunities();
//       fetchNotifications();
//     }
//   }, [currentUserId]);

//   useEffect(() => {
//     if (myCommunities.length > 0) {
//       fetchMemberRequests();
//     }
//   }, [myCommunities]);

//   useEffect(() => {
//     if (selectedCommunity) {
//       fetchCommunityPosts(selectedCommunity.communityId);
//       checkMembership(selectedCommunity.communityId);
//     }
//   }, [selectedCommunity, currentUserId]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString();
//   };

//   return (
//     <div className={classes.root}>
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Box className={classes.header}>
//           <Typography variant="h3" gutterBottom>
//             Community Hub
//           </Typography>
//           <Typography variant="h6">
//             Connect, share, and grow with like-minded individuals
//           </Typography>
//           <Button
//             variant="contained"
//             className={classes.createButton}
//             startIcon={<Add />}
//             onClick={() => {
//               if (!currentUserId) {
//                 history.push('/login');
//               } else {
//                 setCreateDialogOpen(true);
//               }
//             }}
//             sx={{ mt: 2 }}
//           >
//             {currentUserId ? 'Create Community' : 'Login to Create Community'}
//           </Button>
//           {!currentUserId && (
//             <Typography variant="body2" sx={{ mt: 1 }}>
//               Please login to create and join communities
//             </Typography>
//           )}
//         </Box>

//         {/* Tabs */}
//         <div style={{ position: 'relative', marginBottom: '100px' }}>
//           <AppBar
//             sx={{
//               borderRadius: 2,
//               position: 'absolute !important',
//             }}
//             color="default"
//           >
//             <Tabs
//               value={tabValue}
//               onChange={handleTabChange}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="fullWidth"
//             >
//               <Tab label="All Communities" icon={<Public />} />
//               <Tab label="My Communities" icon={<Group />} />
//               <Tab
//                 label={
//                   <Badge badgeContent={notifications.length + memberRequests.length} color="error">
//                     Notifications
//                   </Badge>
//                 }
//                 icon={<Notifications />}
//               />
//             </Tabs>
//           </AppBar>
//         </div>

//         {/* All Communities Tab */}
//         <TabPanel value={tabValue} index={0}>
//           {loading ? (
//             <Typography>Loading communities...</Typography>
//           ) : (
//             <Grid container spacing={3}>
//               {communities.map((community) => (
//                 <Grid item xs={12} sm={6} md={4} key={community.communityId || community._id}>
//                   <Card className={classes.communityCard}>
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Box display="flex" alignItems="center" mb={2}>
//                         <Avatar
//                           sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                           src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                         >
//                           {!community.profilePicture && <Group />}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" gutterBottom>
//                             {community.communityName}
//                           </Typography>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Chip
//                               label={community.type || 'public'}
//                               size="small"
//                               color={community.type === 'public' ? 'primary' : 'secondary'}
//                             />
//                             {isCommunityOwner(community) && (
//                               <Chip
//                                 label="Owner"
//                                 size="small"
//                                 color="success"
//                               />
//                             )}
//                           </Box>
//                         </Box>
//                       </Box>
//                       <Typography variant="body2" color="text.secondary" paragraph>
//                         {community.description}
//                       </Typography>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="text.secondary">
//                           <People sx={{ fontSize: 16, mr: 0.5 }} />
//                           {community.members || 1} members
//                         </Typography>
//                         <Chip label={community.category} variant="outlined" size="small" />
//                       </Box>
//                     </CardContent>
//                     <CardActions>
//                       <Button
//                         size="small"
//                         color="primary"
//                         onClick={() => setSelectedCommunity(community)}
//                       >
//                         View Details
//                       </Button>
//                       {!isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="secondary"
//                           onClick={() => handleJoinCommunity(community)}
//                           disabled={!currentUserId}
//                         >
//                           Join Community
//                         </Button>
//                       )}
//                       {isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="error"
//                           onClick={() => handleDeleteCommunity(community.communityId)}
//                         >
//                           Delete
//                         </Button>
//                       )}
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))}
//               {communities.length === 0 && (
//                 <Grid item xs={12}>
//                   <Typography variant="h6" textAlign="center" color="text.secondary">
//                     No approved communities found. Create one or wait for admin approval.
//                   </Typography>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </TabPanel>

//         {/* My Communities Tab */}
//         <TabPanel value={tabValue} index={1}>
//           {!currentUserId ? (
//             <Typography variant="h6" textAlign="center" color="text.secondary">
//               Please login to view your communities
//             </Typography>
//           ) : loading ? (
//             <Typography>Loading your communities...</Typography>
//           ) : (
//             <>
//               <Typography variant="h5" gutterBottom>
//                 Communities You've Created
//               </Typography>
//               <Grid container spacing={3}>
//                 {myCommunities.map((community) => (
//                   <Grid item xs={12} key={community.communityId || community._id}>
//                     <Card className={classes.communityCard}>
//                       <CardContent>
//                         <Box display="flex" alignItems="center" mb={3}>
//                           <Avatar
//                             sx={{ bgcolor: '#667eea', mr: 2, width: 60, height: 60 }}
//                             src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                           >
//                             {!community.profilePicture && <Group />}
//                           </Avatar>
//                           <Box flexGrow={1}>
//                             <Typography variant="h6" gutterBottom>
//                               {community.communityName}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                               {community.description}
//                             </Typography>
//                           </Box>
//                           <Chip
//                             label={`${community.members || 1} members`}
//                             color="primary"
//                             variant="outlined"
//                           />
//                         </Box>

//                         {/* Create Post Section */}
//                         <Box mb={3}>
//                           <TextField
//                             fullWidth
//                             variant="outlined"
//                             placeholder="Share something with the community..."
//                             value={newPost.content}
//                             onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                             multiline
//                             rows={2}
//                           />

//                           {/* Image upload for post */}
//                           <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <input
//                               accept="image/*"
//                               className={classes.fileInput}
//                               id="post-image-upload"
//                               type="file"
//                               onChange={handlePostImageChange}
//                             />
//                             <label htmlFor="post-image-upload">
//                               <IconButton color="primary" component="span">
//                                 <AddPhotoAlternate />
//                               </IconButton>
//                             </label>
//                             {newPost.imagePreview && (
//                               <>
//                                 <Typography variant="caption">
//                                   Image selected
//                                 </Typography>
//                                 <IconButton
//                                   size="small"
//                                   onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                                 >
//                                   <Cancel fontSize="small" />
//                                 </IconButton>
//                               </>
//                             )}
//                           </Box>

//                           {/* Image preview */}
//                           {newPost.imagePreview && (
//                             <Box sx={{ mt: 1 }}>
//                               <img
//                                 src={newPost.imagePreview}
//                                 alt="Preview"
//                                 className={classes.imagePreview}
//                               />
//                             </Box>
//                           )}

//                           <Box mt={1} display="flex" justifyContent="flex-end">
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               onClick={() => handleCreatePost(community.communityId)}
//                               disabled={(!newPost.content.trim() && !newPost.imageFile)}
//                             >
//                               Post
//                             </Button>
//                           </Box>
//                         </Box>

//                         {/* View Community Button */}
//                         <Box mt={2}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() => setSelectedCommunity(community)}
//                           >
//                             View Community Posts
//                           </Button>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//                 {myCommunities.length === 0 && (
//                   <Grid item xs={12}>
//                     <Typography variant="h6" textAlign="center" color="text.secondary">
//                       You haven't created any communities yet or your communities are pending approval.
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </>
//           )}
//         </TabPanel>

//         {/* Notifications Tab */}
//         <TabPanel value={tabValue} index={2}>
//           <Typography variant="h5" gutterBottom>
//             Notifications
//           </Typography>

//           {/* Member Requests */}
//           {memberRequests.length > 0 && (
//             <Box mb={4}>
//               <Typography variant="h6" gutterBottom>
//                 Member Requests ({memberRequests.length})
//               </Typography>
//               <List>
//                 {memberRequests.map((request) => (
//                   <ListItem
//                     key={request.memberId}
//                     className={classes.notificationItem}
//                     component={Paper}
//                     elevation={1}
//                     sx={{ mb: 2, p: 2 }}
//                   >
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         <Group />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={`Join request from ${request.userName}`}
//                       secondary={
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             {request.communityName} • {formatDate(request.createdAt)}
//                           </Typography>
//                           <Box mt={1} display="flex" gap={1}>
//                             <Button
//                               size="small"
//                               variant="contained"
//                               color="primary"
//                               startIcon={<CheckCircle />}
//                               onClick={() => handleApproveMember(request.memberId, request.communityId)}
//                             >
//                               Approve
//                             </Button>
//                             <Button
//                               size="small"
//                               variant="outlined"
//                               color="secondary"
//                               startIcon={<Cancel />}
//                               onClick={() => handleRejectMember(request.memberId)}
//                             >
//                               Decline
//                             </Button>
//                           </Box>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}

//           {/* Other Notifications */}
//           <List>
//             {notifications.map((notification) => (
//               <ListItem
//                 key={notification.notificationId}
//                 className={classes.notificationItem}
//                 component={Paper}
//                 elevation={1}
//                 sx={{ mb: 2, p: 2 }}
//               >
//                 <ListItemAvatar>
//                   <Avatar sx={{ bgcolor: '#667eea' }}>
//                     <Notifications />
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={notification.message}
//                   secondary={
//                     <Typography variant="body2" color="text.secondary">
//                       {notification.communityName} • {formatDate(notification.createdAt)}
//                     </Typography>
//                   }
//                 />
//               </ListItem>
//             ))}
//             {notifications.length === 0 && memberRequests.length === 0 && (
//               <Typography variant="body2" color="text.secondary" textAlign="center">
//                 No notifications yet.
//               </Typography>
//             )}
//           </List>
//         </TabPanel>

//         {/* Community Details Dialog with Posts */}
//         <Dialog
//           open={!!selectedCommunity}
//           onClose={() => setSelectedCommunity(null)}
//           maxWidth="md"
//           fullWidth
//           scroll="paper"
//         >
//           {selectedCommunity && (
//             <>
//               <DialogTitle>
//                 <Box display="flex" alignItems="center">
//                   <Avatar
//                     sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                     src={selectedCommunity.profilePicture ? `${apiUrl}${selectedCommunity.profilePicture}` : undefined}
//                   >
//                     {!selectedCommunity.profilePicture && <Group />}
//                   </Avatar>
//                   <Box>
//                     <Typography variant="h6">{selectedCommunity.communityName}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {selectedCommunity.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </DialogTitle>
//               <DialogContent>
//                 <Box display="flex" gap={2} mb={2} flexWrap="wrap">
//                   <Chip label={`${selectedCommunity.members || 1} members`} />
//                   <Chip label={selectedCommunity.type || 'public'} color="primary" />
//                   <Chip label={selectedCommunity.category} variant="outlined" />
//                   {isCommunityOwner(selectedCommunity) && (
//                     <Chip label="You are the owner" color="success" />
//                   )}
//                   {isMember && !isCommunityOwner(selectedCommunity) && (
//                     <Chip label="Member" color="primary" variant="outlined" />
//                   )}
//                 </Box>

//                 {/* Create Post (for members and owner) */}
//                 {(isCommunityOwner(selectedCommunity) || isMember) && (
//                   <Box mb={3}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       placeholder="Share something with the community..."
//                       value={newPost.content}
//                       onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                       multiline
//                       rows={2}
//                     />

//                     {/* Image upload for post */}
//                     <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <input
//                         accept="image/*"
//                         className={classes.fileInput}
//                         id="community-post-image-upload"
//                         type="file"
//                         onChange={handlePostImageChange}
//                       />
//                       <label htmlFor="community-post-image-upload">
//                         <IconButton color="primary" component="span">
//                           <AddPhotoAlternate />
//                         </IconButton>
//                       </label>
//                       {newPost.imagePreview && (
//                         <>
//                           <Typography variant="caption">
//                             Image selected
//                           </Typography>
//                           <IconButton
//                             size="small"
//                             onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                           >
//                             <Cancel fontSize="small" />
//                           </IconButton>
//                         </>
//                       )}
//                     </Box>

//                     {/* Image preview */}
//                     {newPost.imagePreview && (
//                       <Box sx={{ mt: 1 }}>
//                         <img
//                           src={newPost.imagePreview}
//                           alt="Preview"
//                           className={classes.imagePreview}
//                         />
//                       </Box>
//                     )}

//                     <Box mt={1} display="flex" justifyContent="flex-end">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => handleCreatePost(selectedCommunity.communityId)}
//                         disabled={!newPost.content.trim() && !newPost.imageFile}
//                       >
//                         Post
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Posts */}
//                 <Typography variant="h6" gutterBottom>
//                   Community Posts
//                 </Typography>
//                 {communityPosts.length > 0 ? (
//                   communityPosts.map((post) => (
//                     <Paper key={post.postId} className={classes.postCard} elevation={1}>
//                       {/* Post Header */}
//                       <Box className={classes.postHeader}>
//                         <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                           {post.userName?.charAt(0) || 'U'}
//                         </Avatar>
//                         <Box flexGrow={1}>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {post.userName}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {formatDate(post.createdAt)}
//                           </Typography>
//                         </Box>
//                         {isCommunityOwner(selectedCommunity) && (
//                           <Tooltip title="Delete Post">
//                             <IconButton
//                               size="small"
//                               color="error"
//                               onClick={() => handleDeletePost(post.postId)}
//                             >
//                               <Delete fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Box>

//                       {/* Post Content */}
//                       <CardContent>
//                         {post.content && (
//                           <Typography variant="body1" paragraph>
//                             {post.content}
//                           </Typography>
//                         )}
//                         {post.imageUrl && (
//                           <Box sx={{ mt: 2 }}>
//                             <img
//                               src={`${apiUrl}${post.imageUrl}`}
//                               alt="Post"
//                               className={classes.imagePreview}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
//                               }}
//                             />
//                           </Box>
//                         )}
//                       </CardContent>

//                       {/* Action Buttons */}
//                       <Box className={classes.actionButtons}>
//                         <IconButton
//                           onClick={() => handleLikePost(post.postId)}
//                           color={userLikes[post.postId] ? 'error' : 'default'}
//                         >
//                           {userLikes[post.postId] ? <Favorite /> : <FavoriteBorder />}
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.likes || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton onClick={() => fetchPostComments(post.postId)}>
//                           <Comment fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.comments || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton>
//                           <Share fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.shares || 0}
//                           </Typography>
//                         </IconButton>
//                       </Box>

//                       {/* Comments Section */}
//                       {postComments[post.postId] && (
//                         <Box className={classes.commentSection}>
//                           <Typography variant="subtitle2" gutterBottom>
//                             Comments:
//                           </Typography>
//                           {postComments[post.postId].map((commentItem) => (
//                             <Box key={commentItem.commentId} mb={1}>
//                               <Typography variant="body2" fontWeight="bold">
//                                 {commentItem.userName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 {commentItem.content}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {formatDate(commentItem.createdAt)}
//                               </Typography>
//                               <Divider sx={{ mt: 1 }} />
//                             </Box>
//                           ))}

//                           {/* Add Comment */}
//                           <Box mt={2} display="flex">
//                             <TextField
//                               fullWidth
//                               size="small"
//                               placeholder="Write a comment..."
//                               value={comment}
//                               onChange={(e) => setComment(e.target.value)}
//                               InputProps={{
//                                 endAdornment: (
//                                   <InputAdornment position="end">
//                                     <IconButton
//                                       color="primary"
//                                       onClick={() => handleAddComment(post.postId)}
//                                       disabled={!comment.trim()}
//                                     >
//                                       <Send />
//                                     </IconButton>
//                                   </InputAdornment>
//                                 ),
//                               }}
//                             />
//                           </Box>
//                         </Box>
//                       )}
//                     </Paper>
//                   ))
//                 ) : (
//                   <Typography color="text.secondary" textAlign="center">
//                     No posts yet. Be the first to post!
//                   </Typography>
//                 )}
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setSelectedCommunity(null)}>Close</Button>
//               </DialogActions>
//             </>
//           )}
//         </Dialog>

//         {/* Create Community Dialog */}
//         <Dialog
//           open={createDialogOpen}
//           onClose={() => setCreateDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>Create New Community</DialogTitle>
//           <DialogContent>
//             <Box component="form" sx={{ mt: 2 }}>
//               <TextField
//                 autoFocus
//                 margin="dense"
//                 label="Community Name *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.communityName}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, communityName: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Description *"
//                 fullWidth
//                 variant="outlined"
//                 multiline
//                 rows={3}
//                 value={newCommunity.description}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, description: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Category *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.category}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, category: e.target.value })}
//                 required
//               />

//               {/* Profile Picture Upload */}
//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <input
//                   accept="image/*"
//                   className={classes.fileInput}
//                   id="profile-picture-upload"
//                   type="file"
//                   onChange={handleProfilePictureChange}
//                 />
//                 <label htmlFor="profile-picture-upload">
//                   <Button variant="outlined" component="span" startIcon={<AddPhotoAlternate />}>
//                     Upload Profile Picture
//                   </Button>
//                 </label>
//                 {profileImagePreview && (
//                   <Box sx={{ mt: 2 }}>
//                     <Typography variant="caption">Preview:</Typography>
//                     <img
//                       src={profileImagePreview}
//                       alt="Profile Preview"
//                       style={{
//                         width: '100px',
//                         height: '100px',
//                         objectFit: 'cover',
//                         borderRadius: '8px',
//                         marginTop: '8px',
//                         border: '1px solid #dee2e6'
//                       }}
//                     />
//                   </Box>
//                 )}
//                 <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
//                   Optional: Upload a profile picture for your community (JPEG, PNG, WEBP, max 5MB)
//                 </Typography>
//               </Box>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setCreateDialogOpen(false)}>Cancel</Button>
//             <Button
//               onClick={handleCreateCommunity}
//               variant="contained"
//               color="primary"
//               disabled={!newCommunity.communityName.trim() ||
//                 !newCommunity.description.trim() ||
//                 !newCommunity.category.trim() ||
//                 loading}
//             >
//               {loading ? 'Creating...' : 'Create Community'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Container>
//     </div>
//   );
// };

// export default Community;



// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   AppBar,
//   Tabs,
//   Tab,
//   Chip,
//   Avatar,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Badge,
//   Divider,
//   Paper,
//   Snackbar,
//   Alert,
//   Input,
//   InputAdornment,
//   Tooltip
// } from '@mui/material';
// import {
//   ThumbUp,
//   Comment,
//   Share,
//   Group,
//   Add,
//   Notifications,
//   Public,
//   Lock,
//   People,
//   Send,
//   Favorite,
//   FavoriteBorder,
//   AddPhotoAlternate,
//   Delete,
//   CheckCircle,
//   Cancel
// } from '@mui/icons-material';
// import { useHistory } from 'react-router-dom';
// import { makeStyles } from '@material-ui/core/styles';
// import { apiUrl } from '../coreservices/environment';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: '#f8f9fa',
//     minHeight: '100vh',
//     paddingTop: theme.spacing(4),
//   },
//   header: {
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     color: 'white',
//     padding: theme.spacing(4),
//     borderRadius: theme.spacing(2),
//     marginBottom: theme.spacing(4),
//   },
//   communityCard: {
//     transition: 'transform 0.2s, box-shadow 0.2s',
//     '&:hover': {
//       transform: 'translateY(-4px)',
//       boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
//     },
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   createButton: {
//     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
//     color: 'white',
//     fontWeight: 'bold',
//     padding: '12px 30px',
//     borderRadius: '25px',
//     '&:hover': {
//       transform: 'scale(1.05)',
//     },
//   },
//   tabPanel: {
//     padding: theme.spacing(3, 0),
//   },
//   postCard: {
//     marginBottom: theme.spacing(3),
//     borderRadius: '12px',
//     overflow: 'hidden',
//   },
//   postHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     borderBottom: '1px solid #e0e0e0',
//   },
//   actionButtons: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     padding: theme.spacing(1, 2),
//   },
//   commentSection: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fafafa',
//   },
//   notificationItem: {
//     borderLeft: '4px solid #667eea',
//     marginBottom: theme.spacing(1),
//   },
//   imagePreview: {
//     maxWidth: '100%',
//     maxHeight: '400px',
//     borderRadius: '8px',
//     marginTop: theme.spacing(2),
//     objectFit: 'contain',
//   },
//   fileInput: {
//     display: 'none',
//   },
// }));

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`community-tabpanel-${index}`}
//       aria-labelledby={`community-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// const Community = () => {
//   const classes = useStyles();
//   const history = useHistory();
//   const [tabValue, setTabValue] = useState(0);
//   const [createDialogOpen, setCreateDialogOpen] = useState(false);
//   const [selectedCommunity, setSelectedCommunity] = useState(null);
//   const [communityPosts, setCommunityPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Get current user data from localStorage
//   const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//   const currentUserId = userData?.userId;
//   const currentUserName = userData?.firstName || 'User';

//   const [newCommunity, setNewCommunity] = useState({
//     communityName: '',
//     description: '',
//     type: 'public',
//     category: '',
//     userId: currentUserId,
//     createdBy: currentUserName,
//     profilePicture: null
//   });

//   const [newPost, setNewPost] = useState({
//     content: '',
//     imageFile: null,
//     imagePreview: null
//   });
//   const [comment, setComment] = useState('');
//   const [postComments, setPostComments] = useState({});

//   // State for dynamic data from API
//   const [communities, setCommunities] = useState([]);
//   const [myCommunities, setMyCommunities] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [memberRequests, setMemberRequests] = useState([]);
//   const [userLikes, setUserLikes] = useState({});
//   const [isMember, setIsMember] = useState(false);
//   const [profileImagePreview, setProfileImagePreview] = useState(null);

//   // Fetch all approved communities
//   const fetchAllCommunities = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${apiUrl}/communitymaster`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunities(data);
//       } else {
//         throw new Error('Failed to fetch communities');
//       }
//     } catch (error) {
//       console.error('Error fetching communities:', error);
//       showSnackbar('Error fetching communities', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch my approved communities
//   const fetchMyCommunities = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/mycommunities/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setMyCommunities(data);
//       } else {
//         throw new Error('Failed to fetch my communities');
//       }
//     } catch (error) {
//       console.error('Error fetching my communities:', error);
//       showSnackbar('Error fetching your communities', 'error');
//     }
//   };

//   // Fetch notifications (filter out inactive)
//   const fetchNotifications = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/notifications/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setNotifications(data.filter(notification => notification.isActive));
//       } else {
//         throw new Error('Failed to fetch notifications');
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//     }
//   };

//   // Fetch community posts
//   const fetchCommunityPosts = async (communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/posts/${communityId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunityPosts(data);

//         // Check likes for each post
//         data.forEach(post => {
//           checkUserLike(post.postId);
//         });
//       } else {
//         throw new Error('Failed to fetch posts');
//       }
//     } catch (error) {
//       console.error('Error fetching posts:', error);
//     }
//   };

//   // Fetch member requests for my communities
//   const fetchMemberRequests = async () => {
//     if (!currentUserId) return;

//     try {
//       const requests = [];
//       for (const community of myCommunities) {
//         const response = await fetch(`${apiUrl}/communitymaster/member/requests/${community.communityId}`);
//         if (response.ok) {
//           const data = await response.json();
//           requests.push(...data.map(req => ({ ...req, communityName: community.communityName })));
//         }
//       }
//       setMemberRequests(requests);
//     } catch (error) {
//       console.error('Error fetching member requests:', error);
//     }
//   };

//   // Check if user has liked a post
//   const checkUserLike = async (postId) => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/like/check/${postId}/${currentUserId}`);
//       if (response.ok) {
//         const hasLiked = await response.json();
//         setUserLikes(prev => ({ ...prev, [postId]: hasLiked }));
//       }
//     } catch (error) {
//       console.error('Error checking like:', error);
//     }
//   };

//   // Check if user is member of community
//   const checkMembership = async (communityId) => {
//     if (!currentUserId || !communityId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/check/${communityId}/${currentUserId}`);
//       if (response.ok) {
//         const isMember = await response.json();
//         setIsMember(isMember);
//       }
//     } catch (error) {
//       console.error('Error checking membership:', error);
//     }
//   };

//   // Create new community with profile picture
//   const handleCreateCommunity = async () => {
//     if (!newCommunity.communityName.trim() || !newCommunity.description.trim() || !newCommunity.category.trim()) {
//       showSnackbar('Please fill all required fields', 'error');
//       return;
//     }

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append('communityName', newCommunity.communityName);
//       formData.append('description', newCommunity.description);
//       formData.append('category', newCommunity.category);
//       formData.append('type', newCommunity.type);
//       formData.append('userId', newCommunity.userId);
//       formData.append('createdBy', newCommunity.createdBy);

//       if (newCommunity.profilePicture instanceof File) {
//         formData.append('profilePicture', newCommunity.profilePicture);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         const result = await response.json();
//         showSnackbar('Community created successfully! Waiting for admin approval.', 'success');
//         setCreateDialogOpen(false);
//         setNewCommunity({
//           communityName: '',
//           description: '',
//           type: 'public',
//           category: '',
//           userId: currentUserId,
//           createdBy: currentUserName,
//           profilePicture: null
//         });
//         setProfileImagePreview(null);

//         // Refresh communities list
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to create community');
//       }
//     } catch (error) {
//       console.error('Error creating community:', error);
//       showSnackbar(error.message || 'Error creating community', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle profile picture upload
//   const handleProfilePictureChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewCommunity({ ...newCommunity, profilePicture: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Join community
//   const handleJoinCommunity = async (community) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to join communities', 'warning');
//       return;
//     }

//     try {
//       const memberRequest = {
//         communityId: community.communityId,
//         userId: currentUserId,
//         status: 'pending',
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/member/request`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(memberRequest),
//       });

//       if (response.ok) {
//         // Create notification for community owner
//         const notification = {
//           communityId: community.communityId,
//           fromUserId: currentUserId,
//           toUserId: community.userId,
//           type: 'join_request',
//           message: `${currentUserName} wants to join your community "${community.communityName}"`,
//           fromUserName: currentUserName,
//           communityName: community.communityName
//         };

//         await fetch(`${apiUrl}/communitymaster/notification`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(notification),
//         });

//         showSnackbar('Join request sent! The community owner will review your request.', 'success');
//       } else {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to send join request');
//       }
//     } catch (error) {
//       console.error('Error joining community:', error);
//       showSnackbar(error.message || 'Error sending join request', 'error');
//     }
//   };

//   // Approve member request
//   const handleApproveMember = async (memberId, communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/approve/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request approved!', 'success');
//         fetchMemberRequests();
//         fetchNotifications(); // Refresh notifications
//         fetchAllCommunities();
//       } else {
//         throw new Error('Failed to approve member');
//       }
//     } catch (error) {
//       console.error('Error approving member:', error);
//       showSnackbar('Error approving member', 'error');
//     }
//   };

//   // Reject member request
//   const handleRejectMember = async (memberId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/reject/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request rejected!', 'success');
//         fetchMemberRequests();
//       } else {
//         throw new Error('Failed to reject member');
//       }
//     } catch (error) {
//       console.error('Error rejecting member:', error);
//       showSnackbar('Error rejecting member', 'error');
//     }
//   };

//   // Create post with image
//   const handleCreatePost = async (communityId) => {
//     if (!newPost.content.trim() && !newPost.imageFile) {
//       showSnackbar('Please add content or an image', 'warning');
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('communityId', communityId);
//       formData.append('userId', currentUserId);
//       formData.append('content', newPost.content);
//       formData.append('userName', currentUserName);

//       if (newPost.imageFile) {
//         formData.append('image', newPost.imageFile);
//       }

//       const response = await fetch(`${apiUrl}/communitymaster/post`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         showSnackbar('Post created successfully!', 'success');
//         setNewPost({ content: '', imageFile: null, imagePreview: null });
//         fetchCommunityPosts(communityId);
//       } else {
//         throw new Error('Failed to create post');
//       }
//     } catch (error) {
//       console.error('Error creating post:', error);
//       showSnackbar('Error creating post', 'error');
//     }
//   };

//   // Handle post image upload
//   const handlePostImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//       if (!validTypes.includes(file.type)) {
//         showSnackbar('Invalid file type. Please upload JPEG, PNG, or WEBP image.', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('File size should be less than 5MB', 'error');
//         return;
//       }

//       setNewPost({ ...newPost, imageFile: file });

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setNewPost(prev => ({ ...prev, imagePreview: reader.result }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Like post
//   const handleLikePost = async (postId) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to like posts', 'warning');
//       return;
//     }

//     try {
//       const likeData = {
//         postId: postId,
//         userId: currentUserId,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/like`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(likeData),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         fetchCommunityPosts(selectedCommunity.communityId);
//         checkUserLike(postId);
//       } else {
//         throw new Error('Failed to like post');
//       }
//     } catch (error) {
//       console.error('Error liking post:', error);
//       showSnackbar('Error liking post', 'error');
//     }
//   };

//   // Add comment
//   const handleAddComment = async (postId) => {
//     if (!comment.trim()) return;

//     try {
//       const commentData = {
//         postId: postId,
//         userId: currentUserId,
//         content: comment,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/comment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(commentData),
//       });

//       if (response.ok) {
//         showSnackbar('Comment added!', 'success');
//         setComment('');
//         fetchPostComments(postId);
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to add comment');
//       }
//     } catch (error) {
//       console.error('Error adding comment:', error);
//       showSnackbar('Error adding comment', 'error');
//     }
//   };

//   // Fetch post comments
//   const fetchPostComments = async (postId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/comments/${postId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setPostComments(prev => ({ ...prev, [postId]: data }));
//       }
//     } catch (error) {
//       console.error('Error fetching comments:', error);
//     }
//   };

//   // Delete community
//   const handleDeleteCommunity = async (communityId) => {
//     if (!window.confirm('Are you sure you want to delete this community?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/${communityId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Community deleted successfully!', 'success');
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         throw new Error('Failed to delete community');
//       }
//     } catch (error) {
//       console.error('Error deleting community:', error);
//       showSnackbar('Error deleting community', 'error');
//     }
//   };

//   // Delete post
//   const handleDeletePost = async (postId) => {
//     if (!window.confirm('Are you sure you want to delete this post?')) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/post/${postId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Post deleted successfully!', 'success');
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to delete post');
//       }
//     } catch (error) {
//       console.error('Error deleting post:', error);
//       showSnackbar('Error deleting post', 'error');
//     }
//   };

//   // Snackbar utility
//   const showSnackbar = (message, severity) => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Check if user owns the community
//   const isCommunityOwner = (community) => {
//     return community.userId === currentUserId;
//   };

//   // Initialize data
//   useEffect(() => {
//     fetchAllCommunities();
//     if (currentUserId) {
//       fetchMyCommunities();
//       fetchNotifications();
//     }
//   }, [currentUserId]);

//   useEffect(() => {
//     if (myCommunities.length > 0) {
//       fetchMemberRequests();
//     }
//   }, [myCommunities]);

//   useEffect(() => {
//     if (selectedCommunity) {
//       fetchCommunityPosts(selectedCommunity.communityId);
//       checkMembership(selectedCommunity.communityId);
//     }
//   }, [selectedCommunity, currentUserId]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString();
//   };

//   return (
//     <div className={classes.root}>
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Box className={classes.header}>
//           <Typography variant="h3" gutterBottom>
//             Community Hub
//           </Typography>
//           <Typography variant="h6">
//             Connect, share, and grow with like-minded individuals
//           </Typography>
//           <Button
//             variant="contained"
//             className={classes.createButton}
//             startIcon={<Add />}
//             onClick={() => {
//               if (!currentUserId) {
//                 history.push('/login');
//               } else {
//                 setCreateDialogOpen(true);
//               }
//             }}
//             sx={{ mt: 2 }}
//           >
//             {currentUserId ? 'Create Community' : 'Login to Create Community'}
//           </Button>
//           {!currentUserId && (
//             <Typography variant="body2" sx={{ mt: 1 }}>
//               Please login to create and join communities
//             </Typography>
//           )}
//         </Box>

//         {/* Tabs */}
//         <div style={{ position: 'relative', marginBottom: '100px' }}>
//           <AppBar
//             sx={{
//               borderRadius: 2,
//               position: 'absolute !important',
//             }}
//             color="default"
//           >
//             <Tabs
//               value={tabValue}
//               onChange={handleTabChange}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="fullWidth"
//             >
//               <Tab label="All Communities" icon={<Public />} />
//               <Tab label="My Communities" icon={<Group />} />
//               <Tab
//                 label={
//                   <Badge badgeContent={notifications.length + memberRequests.length} color="error">
//                     Notifications
//                   </Badge>
//                 }
//                 icon={<Notifications />}
//               />
//             </Tabs>
//           </AppBar>
//         </div>

//         {/* All Communities Tab */}
//         <TabPanel value={tabValue} index={0}>
//           {loading ? (
//             <Typography>Loading communities...</Typography>
//           ) : (
//             <Grid container spacing={3}>
//               {communities.map((community) => (
//                 <Grid item xs={12} sm={6} md={4} key={community.communityId || community._id}>
//                   <Card className={classes.communityCard}>
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Box display="flex" alignItems="center" mb={2}>
//                         <Avatar
//                           sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                           src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                         >
//                           {!community.profilePicture && <Group />}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" gutterBottom>
//                             {community.communityName}
//                           </Typography>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Chip
//                               label={community.type || 'public'}
//                               size="small"
//                               color={community.type === 'public' ? 'primary' : 'secondary'}
//                             />
//                             {isCommunityOwner(community) && (
//                               <Chip
//                                 label="Owner"
//                                 size="small"
//                                 color="success"
//                               />
//                             )}
//                           </Box>
//                         </Box>
//                       </Box>
//                       <Typography variant="body2" color="text.secondary" paragraph>
//                         {community.description}
//                       </Typography>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="text.secondary">
//                           <People sx={{ fontSize: 16, mr: 0.5 }} />
//                           {community.members || 1} members
//                         </Typography>
//                         <Chip label={community.category} variant="outlined" size="small" />
//                       </Box>
//                     </CardContent>
//                     <CardActions>
//                       <Button
//                         size="small"
//                         color="primary"
//                         onClick={() => setSelectedCommunity(community)}
//                       >
//                         View Details
//                       </Button>
//                       {!isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="secondary"
//                           onClick={() => handleJoinCommunity(community)}
//                           disabled={!currentUserId}
//                         >
//                           Join Community
//                         </Button>
//                       )}
//                       {isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="error"
//                           onClick={() => handleDeleteCommunity(community.communityId)}
//                         >
//                           Delete
//                         </Button>
//                       )}
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))}
//               {communities.length === 0 && (
//                 <Grid item xs={12}>
//                   <Typography variant="h6" textAlign="center" color="text.secondary">
//                     No approved communities found. Create one or wait for admin approval.
//                   </Typography>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </TabPanel>

//         {/* My Communities Tab */}
//         <TabPanel value={tabValue} index={1}>
//           {!currentUserId ? (
//             <Typography variant="h6" textAlign="center" color="text.secondary">
//               Please login to view your communities
//             </Typography>
//           ) : loading ? (
//             <Typography>Loading your communities...</Typography>
//           ) : (
//             <>
//               <Typography variant="h5" gutterBottom>
//                 Communities You've Created
//               </Typography>
//               <Grid container spacing={3}>
//                 {myCommunities.map((community) => (
//                   <Grid item xs={12} key={community.communityId || community._id}>
//                     <Card className={classes.communityCard}>
//                       <CardContent>
//                         <Box display="flex" alignItems="center" mb={3}>
//                           <Avatar
//                             sx={{ bgcolor: '#667eea', mr: 2, width: 60, height: 60 }}
//                             src={community.profilePicture ? `${apiUrl}${community.profilePicture}` : undefined}
//                           >
//                             {!community.profilePicture && <Group />}
//                           </Avatar>
//                           <Box flexGrow={1}>
//                             <Typography variant="h6" gutterBottom>
//                               {community.communityName}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                               {community.description}
//                             </Typography>
//                           </Box>
//                           <Chip
//                             label={`${community.members || 1} members`}
//                             color="primary"
//                             variant="outlined"
//                           />
//                         </Box>

//                         {/* Create Post Section */}
//                         <Box mb={3}>
//                           <TextField
//                             fullWidth
//                             variant="outlined"
//                             placeholder="Share something with the community..."
//                             value={newPost.content}
//                             onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                             multiline
//                             rows={2}
//                           />

//                           {/* Image upload for post */}
//                           <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <input
//                               accept="image/*"
//                               className={classes.fileInput}
//                               id="post-image-upload"
//                               type="file"
//                               onChange={handlePostImageChange}
//                             />
//                             <label htmlFor="post-image-upload">
//                               <IconButton color="primary" component="span">
//                                 <AddPhotoAlternate />
//                               </IconButton>
//                             </label>
//                             {newPost.imagePreview && (
//                               <>
//                                 <Typography variant="caption">
//                                   Image selected
//                                 </Typography>
//                                 <IconButton
//                                   size="small"
//                                   onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                                 >
//                                   <Cancel fontSize="small" />
//                                 </IconButton>
//                               </>
//                             )}
//                           </Box>

//                           {/* Image preview */}
//                           {newPost.imagePreview && (
//                             <Box sx={{ mt: 1 }}>
//                               <img
//                                 src={newPost.imagePreview}
//                                 alt="Preview"
//                                 className={classes.imagePreview}
//                               />
//                             </Box>
//                           )}

//                           <Box mt={1} display="flex" justifyContent="flex-end">
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               onClick={() => handleCreatePost(community.communityId)}
//                               disabled={(!newPost.content.trim() && !newPost.imageFile)}
//                             >
//                               Post
//                             </Button>
//                           </Box>
//                         </Box>

//                         {/* View Community Button */}
//                         <Box mt={2}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() => setSelectedCommunity(community)}
//                           >
//                             View Community Posts
//                           </Button>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//                 {myCommunities.length === 0 && (
//                   <Grid item xs={12}>
//                     <Typography variant="h6" textAlign="center" color="text.secondary">
//                       You haven't created any communities yet or your communities are pending approval.
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </>
//           )}
//         </TabPanel>

//         {/* Notifications Tab */}
//         <TabPanel value={tabValue} index={2}>
//           <Typography variant="h5" gutterBottom>
//             Notifications
//           </Typography>

//           {/* Member Requests */}
//           {memberRequests.length > 0 && (
//             <Box mb={4}>
//               <Typography variant="h6" gutterBottom>
//                 Member Requests ({memberRequests.length})
//               </Typography>
//               <List>
//                 {memberRequests.map((request) => (
//                   <ListItem
//                     key={request.memberId}
//                     className={classes.notificationItem}
//                     component={Paper}
//                     elevation={1}
//                     sx={{ mb: 2, p: 2 }}
//                   >
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         <Group />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={`Join request from ${request.userName}`}
//                       secondary={
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             {request.communityName} • {formatDate(request.createdAt)}
//                           </Typography>
//                           <Box mt={1} display="flex" gap={1}>
//                             <Button
//                               size="small"
//                               variant="contained"
//                               color="primary"
//                               startIcon={<CheckCircle />}
//                               onClick={() => handleApproveMember(request.memberId, request.communityId)}
//                             >
//                               Approve
//                             </Button>
//                             <Button
//                               size="small"
//                               variant="outlined"
//                               color="secondary"
//                               startIcon={<Cancel />}
//                               onClick={() => handleRejectMember(request.memberId)}
//                             >
//                               Decline
//                             </Button>
//                           </Box>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}

//           {/* Other Notifications */}
//           <List>
//             {notifications.map((notification) => (
//               <ListItem
//                 key={notification.notificationId}
//                 className={classes.notificationItem}
//                 component={Paper}
//                 elevation={1}
//                 sx={{ mb: 2, p: 2 }}
//               >
//                 <ListItemAvatar>
//                   <Avatar sx={{ bgcolor: '#667eea' }}>
//                     <Notifications />
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={notification.message}
//                   secondary={
//                     <Typography variant="body2" color="text.secondary">
//                       {notification.communityName} • {formatDate(notification.createdAt)}
//                     </Typography>
//                   }
//                 />
//               </ListItem>
//             ))}
//             {notifications.length === 0 && memberRequests.length === 0 && (
//               <Typography variant="body2" color="text.secondary" textAlign="center">
//                 No notifications yet.
//               </Typography>
//             )}
//           </List>
//         </TabPanel>

//         {/* Community Details Dialog with Posts */}
//         <Dialog
//           open={!!selectedCommunity}
//           onClose={() => setSelectedCommunity(null)}
//           maxWidth="md"
//           fullWidth
//           scroll="paper"
//         >
//           {selectedCommunity && (
//             <>
//               <DialogTitle>
//                 <Box display="flex" alignItems="center">
//                   <Avatar
//                     sx={{ bgcolor: '#667eea', mr: 2, width: 56, height: 56 }}
//                     src={selectedCommunity.profilePicture ? `${apiUrl}${selectedCommunity.profilePicture}` : undefined}
//                   >
//                     {!selectedCommunity.profilePicture && <Group />}
//                   </Avatar>
//                   <Box>
//                     <Typography variant="h6">{selectedCommunity.communityName}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {selectedCommunity.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </DialogTitle>
//               <DialogContent>
//                 <Box display="flex" gap={2} mb={2} flexWrap="wrap">
//                   <Chip label={`${selectedCommunity.members || 1} members`} />
//                   <Chip label={selectedCommunity.type || 'public'} color="primary" />
//                   <Chip label={selectedCommunity.category} variant="outlined" />
//                   {isCommunityOwner(selectedCommunity) && (
//                     <Chip label="You are the owner" color="success" />
//                   )}
//                   {isMember && !isCommunityOwner(selectedCommunity) && (
//                     <Chip label="Member" color="primary" variant="outlined" />
//                   )}
//                 </Box>

//                 {/* Create Post (for members and owner) */}
//                 {(isCommunityOwner(selectedCommunity) || isMember) && (
//                   <Box mb={3}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       placeholder="Share something with the community..."
//                       value={newPost.content}
//                       onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
//                       multiline
//                       rows={2}
//                     />

//                     {/* Image upload for post */}
//                     <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <input
//                         accept="image/*"
//                         className={classes.fileInput}
//                         id="community-post-image-upload"
//                         type="file"
//                         onChange={handlePostImageChange}
//                       />
//                       <label htmlFor="community-post-image-upload">
//                         <IconButton color="primary" component="span">
//                           <AddPhotoAlternate />
//                         </IconButton>
//                       </label>
//                       {newPost.imagePreview && (
//                         <>
//                           <Typography variant="caption">
//                             Image selected
//                           </Typography>
//                           <IconButton
//                             size="small"
//                             onClick={() => setNewPost({ ...newPost, imageFile: null, imagePreview: null })}
//                           >
//                             <Cancel fontSize="small" />
//                           </IconButton>
//                         </>
//                       )}
//                     </Box>

//                     {/* Image preview */}
//                     {newPost.imagePreview && (
//                       <Box sx={{ mt: 1 }}>
//                         <img
//                           src={newPost.imagePreview}
//                           alt="Preview"
//                           className={classes.imagePreview}
//                         />
//                       </Box>
//                     )}

//                     <Box mt={1} display="flex" justifyContent="flex-end">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => handleCreatePost(selectedCommunity.communityId)}
//                         disabled={!newPost.content.trim() && !newPost.imageFile}
//                       >
//                         Post
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Posts */}
//                 <Typography variant="h6" gutterBottom>
//                   Community Posts
//                 </Typography>
//                 {communityPosts.length > 0 ? (
//                   communityPosts.map((post) => (
//                     <Paper key={post.postId} className={classes.postCard} elevation={1}>
//                       {/* Post Header */}
//                       <Box className={classes.postHeader}>
//                         <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                           {post.userName?.charAt(0) || 'U'}
//                         </Avatar>
//                         <Box flexGrow={1}>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {post.userName}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {formatDate(post.createdAt)}
//                           </Typography>
//                         </Box>
//                         {isCommunityOwner(selectedCommunity) && (
//                           <Tooltip title="Delete Post">
//                             <IconButton
//                               size="small"
//                               color="error"
//                               onClick={() => handleDeletePost(post.postId)}
//                             >
//                               <Delete fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Box>

//                       {/* Post Content */}
//                       <CardContent>
//                         {post.content && (
//                           <Typography variant="body1" paragraph>
//                             {post.content}
//                           </Typography>
//                         )}
//                         {post.imageUrl && (
//                           <Box sx={{ mt: 2 }}>
//                             <img
//                               src={`${apiUrl}${post.imageUrl}`}
//                               alt="Post"
//                               className={classes.imagePreview}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
//                               }}
//                             />
//                           </Box>
//                         )}
//                       </CardContent>

//                       {/* Action Buttons */}
//                       <Box className={classes.actionButtons}>
//                         <IconButton
//                           onClick={() => handleLikePost(post.postId)}
//                           color={userLikes[post.postId] ? 'error' : 'default'}
//                         >
//                           {userLikes[post.postId] ? <Favorite /> : <FavoriteBorder />}
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.likes || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton onClick={() => fetchPostComments(post.postId)}>
//                           <Comment fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.comments || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton>
//                           <Share fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.shares || 0}
//                           </Typography>
//                         </IconButton>
//                       </Box>

//                       {/* Comments Section */}
//                       {postComments[post.postId] && (
//                         <Box className={classes.commentSection}>
//                           <Typography variant="subtitle2" gutterBottom>
//                             Comments:
//                           </Typography>
//                           {postComments[post.postId].map((commentItem) => (
//                             <Box key={commentItem.commentId} mb={1}>
//                               <Typography variant="body2" fontWeight="bold">
//                                 {commentItem.userName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 {commentItem.content}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {formatDate(commentItem.createdAt)}
//                               </Typography>
//                               <Divider sx={{ mt: 1 }} />
//                             </Box>
//                           ))}

//                           {/* Add Comment */}
//                           <Box mt={2} display="flex">
//                             <TextField
//                               fullWidth
//                               size="small"
//                               placeholder="Write a comment..."
//                               value={comment}
//                               onChange={(e) => setComment(e.target.value)}
//                               InputProps={{
//                                 endAdornment: (
//                                   <InputAdornment position="end">
//                                     <IconButton
//                                       color="primary"
//                                       onClick={() => handleAddComment(post.postId)}
//                                       disabled={!comment.trim()}
//                                     >
//                                       <Send />
//                                     </IconButton>
//                                   </InputAdornment>
//                                 ),
//                               }}
//                             />
//                           </Box>
//                         </Box>
//                       )}
//                     </Paper>
//                   ))
//                 ) : (
//                   <Typography color="text.secondary" textAlign="center">
//                     No posts yet. Be the first to post!
//                   </Typography>
//                 )}
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setSelectedCommunity(null)}>Close</Button>
//               </DialogActions>
//             </>
//           )}
//         </Dialog>

//         {/* Create Community Dialog */}
//         <Dialog
//           open={createDialogOpen}
//           onClose={() => setCreateDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>Create New Community</DialogTitle>
//           <DialogContent>
//             <Box component="form" sx={{ mt: 2 }}>
//               <TextField
//                 autoFocus
//                 margin="dense"
//                 label="Community Name *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.communityName}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, communityName: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Description *"
//                 fullWidth
//                 variant="outlined"
//                 multiline
//                 rows={3}
//                 value={newCommunity.description}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, description: e.target.value })}
//                 required
//               />
//               <TextField
//                 margin="dense"
//                 label="Category *"
//                 fullWidth
//                 variant="outlined"
//                 value={newCommunity.category}
//                 onChange={(e) => setNewCommunity({ ...newCommunity, category: e.target.value })}
//                 required
//               />

//               {/* Profile Picture Upload */}
//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <input
//                   accept="image/*"
//                   className={classes.fileInput}
//                   id="profile-picture-upload"
//                   type="file"
//                   onChange={handleProfilePictureChange}
//                 />
//                 <label htmlFor="profile-picture-upload">
//                   <Button variant="outlined" component="span" startIcon={<AddPhotoAlternate />}>
//                     Upload Profile Picture
//                   </Button>
//                 </label>
//                 {profileImagePreview && (
//                   <Box sx={{ mt: 2 }}>
//                     <Typography variant="caption">Preview:</Typography>
//                     <img
//                       src={profileImagePreview}
//                       alt="Profile Preview"
//                       style={{
//                         width: '100px',
//                         height: '100px',
//                         objectFit: 'cover',
//                         borderRadius: '8px',
//                         marginTop: '8px',
//                         border: '1px solid #dee2e6'
//                       }}
//                     />
//                   </Box>
//                 )}
//                 <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
//                   Optional: Upload a profile picture for your community (JPEG, PNG, WEBP, max 5MB)
//                 </Typography>
//               </Box>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setCreateDialogOpen(false)}>Cancel</Button>
//             <Button
//               onClick={handleCreateCommunity}
//               variant="contained"
//               color="primary"
//               disabled={!newCommunity.communityName.trim() ||
//                 !newCommunity.description.trim() ||
//                 !newCommunity.category.trim() ||
//                 loading}
//             >
//               {loading ? 'Creating...' : 'Create Community'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Container>
//     </div>
//   );
// };

// export default Community;



// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   AppBar,
//   Tabs,
//   Tab,
//   Chip,
//   Avatar,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Badge,
//   Divider,
//   Paper,
//   Snackbar,
//   Alert
// } from '@mui/material';
// import {
//   ThumbUp,
//   Comment,
//   Share,
//   Group,
//   Add,
//   Notifications,
//   Public,
//   Lock,
//   People,
//   Send,
//   Favorite,
//   FavoriteBorder
// } from '@mui/icons-material';
// import { useHistory } from 'react-router-dom';
// import { makeStyles } from '@material-ui/core/styles';
// import { apiUrl } from '../coreservices/environment';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: '#f8f9fa',
//     minHeight: '100vh',
//     paddingTop: theme.spacing(4),
//   },
//   header: {
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     color: 'white',
//     padding: theme.spacing(4),
//     borderRadius: theme.spacing(2),
//     marginBottom: theme.spacing(4),
//   },
//   communityCard: {
//     transition: 'transform 0.2s, box-shadow 0.2s',
//     '&:hover': {
//       transform: 'translateY(-4px)',
//       boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
//     },
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   createButton: {
//     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
//     color: 'white',
//     fontWeight: 'bold',
//     padding: '12px 30px',
//     borderRadius: '25px',
//     '&:hover': {
//       transform: 'scale(1.05)',
//     },
//   },
//   tabPanel: {
//     padding: theme.spacing(3, 0),
//   },
//   postCard: {
//     marginBottom: theme.spacing(3),
//     borderRadius: '12px',
//     overflow: 'hidden',
//   },
//   postHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     borderBottom: '1px solid #e0e0e0',
//   },
//   actionButtons: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     padding: theme.spacing(1, 2),
//   },
//   commentSection: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fafafa',
//   },
//   notificationItem: {
//     borderLeft: '4px solid #667eea',
//     marginBottom: theme.spacing(1),
//   },
// }));

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`community-tabpanel-${index}`}
//       aria-labelledby={`community-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// const Community = () => {
//   const classes = useStyles();
//   const history = useHistory();
//   const [tabValue, setTabValue] = useState(0);
//   const [createDialogOpen, setCreateDialogOpen] = useState(false);
//   const [selectedCommunity, setSelectedCommunity] = useState(null);
//   const [communityPosts, setCommunityPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Get current user data from localStorage
//   const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//   console.log("userData", userData);

//   const currentUserId = userData?.userId;
//   const currentUserName = userData?.firstName || 'User';

//   const [newCommunity, setNewCommunity] = useState({
//     communityName: '',
//     description: '',
//     type: 'public',
//     category: '',
//     userId: currentUserId,
//     createdBy: currentUserName
//   });

//   const [newPost, setNewPost] = useState({ content: '' });
//   const [comment, setComment] = useState('');
//   const [postComments, setPostComments] = useState({});

//   // State for dynamic data from API
//   const [communities, setCommunities] = useState([]);
//   const [myCommunities, setMyCommunities] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [memberRequests, setMemberRequests] = useState([]);
//   const [userLikes, setUserLikes] = useState({});

//   // Fetch all communities
//   const fetchAllCommunities = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${apiUrl}/communitymaster`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunities(data);
//       } else {
//         throw new Error('Failed to fetch communities');
//       }
//     } catch (error) {
//       console.error('Error fetching communities:', error);
//       showSnackbar('Error fetching communities', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch my communities
//   const fetchMyCommunities = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/mycommunities/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setMyCommunities(data);
//       } else {
//         throw new Error('Failed to fetch my communities');
//       }
//     } catch (error) {
//       console.error('Error fetching my communities:', error);
//       showSnackbar('Error fetching your communities', 'error');
//     }
//   };

//   // Fetch notifications
//   const fetchNotifications = async () => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/notifications/${currentUserId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setNotifications(data);
//       } else {
//         throw new Error('Failed to fetch notifications');
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//     }
//   };

//   // Fetch community posts
//   const fetchCommunityPosts = async (communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/posts/${communityId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setCommunityPosts(data);

//         // Check likes for each post
//         data.forEach(post => {
//           checkUserLike(post.postId);
//         });
//       } else {
//         throw new Error('Failed to fetch posts');
//       }
//     } catch (error) {
//       console.error('Error fetching posts:', error);
//     }
//   };

//   // Fetch member requests for my communities
//   const fetchMemberRequests = async () => {
//     if (!currentUserId) return;

//     try {
//       const requests = [];
//       for (const community of myCommunities) {
//         const response = await fetch(`${apiUrl}/communitymaster/member/requests/${community.communityId}`);
//         if (response.ok) {
//           const data = await response.json();
//           requests.push(...data.map(req => ({ ...req, communityName: community.communityName })));
//         }
//       }
//       setMemberRequests(requests);
//     } catch (error) {
//       console.error('Error fetching member requests:', error);
//     }
//   };

//   // Check if user has liked a post
//   const checkUserLike = async (postId) => {
//     if (!currentUserId) return;

//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/like/check/${postId}/${currentUserId}`);
//       if (response.ok) {
//         const hasLiked = await response.json();
//         setUserLikes(prev => ({ ...prev, [postId]: hasLiked }));
//       }
//     } catch (error) {
//       console.error('Error checking like:', error);
//     }
//   };

//   // Create new community
//   const handleCreateCommunity = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${apiUrl}/communitymaster`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(newCommunity),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         showSnackbar('Community created successfully!', 'success');
//         setCreateDialogOpen(false);
//         setNewCommunity({
//           communityName: '',
//           description: '',
//           type: 'public',
//           category: '',
//           userId: currentUserId,
//           createdBy: currentUserName
//         });

//         // Refresh communities list
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         throw new Error('Failed to create community');
//       }
//     } catch (error) {
//       console.error('Error creating community:', error);
//       showSnackbar('Error creating community', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Join community
//   const handleJoinCommunity = async (community) => {
//     try {
//       const memberRequest = {
//         communityId: community.communityId,
//         userId: currentUserId,
//         status: 'pending',
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/member/request`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(memberRequest),
//       });

//       if (response.ok) {
//         // Create notification for community owner
//         const notification = {
//           communityId: community.communityId,
//           fromUserId: currentUserId,
//           toUserId: community.userId,
//           type: 'join_request',
//           message: `${currentUserName} wants to join your community "${community.communityName}"`,
//           fromUserName: currentUserName,
//           communityName: community.communityName
//         };

//         await fetch(`${apiUrl}/communitymaster/notification`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(notification),
//         });

//         showSnackbar('Join request sent! The community owner will review your request.', 'success');
//       } else {
//         throw new Error('Failed to send join request');
//       }
//     } catch (error) {
//       console.error('Error joining community:', error);
//       showSnackbar('Error sending join request', 'error');
//     }
//   };

//   // Approve member request
//   const handleApproveMember = async (memberId, communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/approve/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request approved!', 'success');
//         fetchMemberRequests();
//         fetchAllCommunities();
//       } else {
//         throw new Error('Failed to approve member');
//       }
//     } catch (error) {
//       console.error('Error approving member:', error);
//       showSnackbar('Error approving member', 'error');
//     }
//   };

//   // Reject member request
//   const handleRejectMember = async (memberId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/member/reject/${memberId}`, {
//         method: 'PUT',
//       });

//       if (response.ok) {
//         showSnackbar('Member request rejected!', 'success');
//         fetchMemberRequests();
//       } else {
//         throw new Error('Failed to reject member');
//       }
//     } catch (error) {
//       console.error('Error rejecting member:', error);
//       showSnackbar('Error rejecting member', 'error');
//     }
//   };

//   // Create post
//   const handleCreatePost = async (communityId) => {
//     if (!newPost.content.trim()) return;

//     try {
//       const postData = {
//         communityId: communityId,
//         userId: currentUserId,
//         content: newPost.content,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/post`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(postData),
//       });

//       if (response.ok) {
//         showSnackbar('Post created successfully!', 'success');
//         setNewPost({ content: '' });
//         fetchCommunityPosts(communityId);
//       } else {
//         throw new Error('Failed to create post');
//       }
//     } catch (error) {
//       console.error('Error creating post:', error);
//       showSnackbar('Error creating post', 'error');
//     }
//   };

//   // Like post
//   const handleLikePost = async (postId) => {
//     if (!currentUserId) {
//       showSnackbar('Please login to like posts', 'warning');
//       return;
//     }

//     try {
//       const likeData = {
//         postId: postId,
//         userId: currentUserId,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/like`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(likeData),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         fetchCommunityPosts(selectedCommunity.communityId);
//         checkUserLike(postId);
//       } else {
//         throw new Error('Failed to like post');
//       }
//     } catch (error) {
//       console.error('Error liking post:', error);
//       showSnackbar('Error liking post', 'error');
//     }
//   };

//   // Add comment
//   const handleAddComment = async (postId) => {
//     if (!comment.trim()) return;

//     try {
//       const commentData = {
//         postId: postId,
//         userId: currentUserId,
//         content: comment,
//         userName: currentUserName
//       };

//       const response = await fetch(`${apiUrl}/communitymaster/comment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(commentData),
//       });

//       if (response.ok) {
//         showSnackbar('Comment added!', 'success');
//         setComment('');
//         fetchPostComments(postId);
//         fetchCommunityPosts(selectedCommunity.communityId);
//       } else {
//         throw new Error('Failed to add comment');
//       }
//     } catch (error) {
//       console.error('Error adding comment:', error);
//       showSnackbar('Error adding comment', 'error');
//     }
//   };

//   // Fetch post comments
//   const fetchPostComments = async (postId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/comments/${postId}`);
//       if (response.ok) {
//         const data = await response.json();
//         setPostComments(prev => ({ ...prev, [postId]: data }));
//       }
//     } catch (error) {
//       console.error('Error fetching comments:', error);
//     }
//   };

//   // Delete community
//   const handleDeleteCommunity = async (communityId) => {
//     try {
//       const response = await fetch(`${apiUrl}/communitymaster/${communityId}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         showSnackbar('Community deleted successfully!', 'success');
//         fetchAllCommunities();
//         fetchMyCommunities();
//       } else {
//         throw new Error('Failed to delete community');
//       }
//     } catch (error) {
//       console.error('Error deleting community:', error);
//       showSnackbar('Error deleting community', 'error');
//     }
//   };

//   // Snackbar utility
//   const showSnackbar = (message, severity) => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Initialize data
//   useEffect(() => {
//     fetchAllCommunities();
//     if (currentUserId) {
//       fetchMyCommunities();
//       fetchNotifications();
//     }
//   }, [currentUserId]);

//   useEffect(() => {
//     if (myCommunities.length > 0) {
//       fetchMemberRequests();
//     }
//   }, [myCommunities]);

//   useEffect(() => {
//     if (selectedCommunity) {
//       fetchCommunityPosts(selectedCommunity.communityId);
//     }
//   }, [selectedCommunity]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   // Check if user owns the community
//   const isCommunityOwner = (community) => {
//     return community.userId === currentUserId;
//   };

//   // Check if user is member of community
//   const [isMember, setIsMember] = useState(false);
//   useEffect(() => {
//     const checkMembership = async () => {
//       if (selectedCommunity && currentUserId) {
//         try {
//           const response = await fetch(`${apiUrl}/communitymaster/member/check/${selectedCommunity.communityId}/${currentUserId}`);
//           if (response.ok) {
//             const isMember = await response.json();
//             setIsMember(isMember);
//           }
//         } catch (error) {
//           console.error('Error checking membership:', error);
//         }
//       }
//     };
//     checkMembership();
//   }, [selectedCommunity, currentUserId]);

//   return (
//     <div className={classes.root}>
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Box className={classes.header}>
//           <Typography variant="h3" gutterBottom>
//             Community Hub
//           </Typography>
//           <Typography variant="h6">
//             Connect, share, and grow with like-minded individuals
//           </Typography>
//           <Button
//             variant="contained"
//             className={classes.createButton}
//             startIcon={<Add />}
//             onClick={() => {
//               if (!currentUserId) {
//                 history.push('/login');
//               }
//               setCreateDialogOpen(true)
//             }}
//             sx={{ mt: 2 }}
//           // disabled={!currentUserId}
//           >
//             {currentUserId ? 'Create Community' : 'Login to Create Community'}
//           </Button>
//           {!currentUserId && (
//             <Typography variant="body2" sx={{ mt: 1 }}>
//               Please login to create and join communities
//             </Typography>
//           )}
//         </Box>

//         {/* Tabs */}
//         <div style={{ position: 'relative', marginBottom: '100px' }}>
//           <AppBar
//             sx={{
//               borderRadius: 2,
//               position: 'absolute !important',
//             }}
//             color="default"
//           >
//             <Tabs
//               value={tabValue}
//               onChange={handleTabChange}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="fullWidth"
//             >
//               <Tab label="All Communities" icon={<Public />} />
//               <Tab label="My Communities" icon={<Group />} />
//               <Tab
//                 label={
//                   <Badge badgeContent={notifications.length + memberRequests.length} color="error">
//                     Notifications
//                   </Badge>
//                 }
//                 icon={<Notifications />}
//               />
//             </Tabs>
//           </AppBar>
//         </div>

//         {/* All Communities Tab */}
//         <TabPanel value={tabValue} index={0}>
//           {loading ? (
//             <Typography>Loading communities...</Typography>
//           ) : (
//             <Grid container spacing={3}>
//               {communities.map((community) => (
//                 <Grid item xs={12} sm={6} md={4} key={community.communityId || community._id}>
//                   <Card className={classes.communityCard}>
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Box display="flex" alignItems="center" mb={2}>
//                         <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                           <Group />
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" gutterBottom>
//                             {community.communityName}
//                           </Typography>
//                           <Chip
//                             label={community.type || 'public'}
//                             size="small"
//                             color={community.type === 'public' ? 'primary' : 'secondary'}
//                           />
//                           {isCommunityOwner(community) && (
//                             <Chip
//                               label="Owner"
//                               size="small"
//                               color="success"
//                               sx={{ ml: 1 }}
//                             />
//                           )}
//                         </Box>
//                       </Box>
//                       <Typography variant="body2" color="text.secondary" paragraph>
//                         {community.description}
//                       </Typography>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="text.secondary">
//                           <People sx={{ fontSize: 16, mr: 0.5 }} />
//                           {community.members || 1} members
//                         </Typography>
//                         <Chip label={community.category} variant="outlined" size="small" />
//                       </Box>
//                     </CardContent>
//                     <CardActions>
//                       <Button
//                         size="small"
//                         color="primary"
//                         onClick={() => setSelectedCommunity(community)}
//                       >
//                         View Details
//                       </Button>
//                       {!isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="secondary"
//                           onClick={() => handleJoinCommunity(community)}
//                           disabled={!currentUserId}
//                         >
//                           Join Community
//                         </Button>
//                       )}
//                       {isCommunityOwner(community) && (
//                         <Button
//                           size="small"
//                           color="error"
//                           onClick={() => handleDeleteCommunity(community.communityId)}
//                         >
//                           Delete
//                         </Button>
//                       )}
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))}
//               {communities.length === 0 && (
//                 <Grid item xs={12}>
//                   <Typography variant="h6" textAlign="center" color="text.secondary">
//                     No communities found. Be the first to create one!
//                   </Typography>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </TabPanel>

//         {/* My Communities Tab */}
//         <TabPanel value={tabValue} index={1}>
//           {!currentUserId ? (
//             <Typography variant="h6" textAlign="center" color="text.secondary">
//               Please login to view your communities
//             </Typography>
//           ) : loading ? (
//             <Typography>Loading your communities...</Typography>
//           ) : (
//             <>
//               <Typography variant="h5" gutterBottom>
//                 Communities You've Created
//               </Typography>
//               <Grid container spacing={3}>
//                 {myCommunities.map((community) => (
//                   <Grid item xs={12} key={community.communityId || community._id}>
//                     <Card className={classes.communityCard}>
//                       <CardContent>
//                         <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                           <Box>
//                             <Typography variant="h6" gutterBottom>
//                               {community.communityName}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                               {community.description}
//                             </Typography>
//                           </Box>
//                           <Chip
//                             label={`${community.members || 1} members`}
//                             color="primary"
//                             variant="outlined"
//                           />
//                         </Box>

//                         {/* Create Post Section */}
//                         <Box mb={3}>
//                           <TextField
//                             fullWidth
//                             variant="outlined"
//                             placeholder="Share something with the community..."
//                             value={newPost.content}
//                             onChange={(e) => setNewPost({ content: e.target.value })}
//                             multiline
//                             rows={2}
//                           />
//                           <Box mt={1} display="flex" justifyContent="flex-end">
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               onClick={() => handleCreatePost(community.communityId)}
//                               disabled={!newPost.content.trim()}
//                             >
//                               Post
//                             </Button>
//                           </Box>
//                         </Box>

//                         {/* View Community Button */}
//                         <Box mt={2}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() => setSelectedCommunity(community)}
//                           >
//                             View Community Posts
//                           </Button>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//                 {myCommunities.length === 0 && (
//                   <Grid item xs={12}>
//                     <Typography variant="h6" textAlign="center" color="text.secondary">
//                       You haven't created any communities yet.
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </>
//           )}
//         </TabPanel>

//         {/* Notifications Tab */}
//         <TabPanel value={tabValue} index={2}>
//           <Typography variant="h5" gutterBottom>
//             Notifications
//           </Typography>

//           {/* Member Requests */}
//           {memberRequests.length > 0 && (
//             <Box mb={4}>
//               <Typography variant="h6" gutterBottom>
//                 Member Requests
//               </Typography>
//               <List>
//                 {memberRequests.map((request) => (
//                   <ListItem
//                     key={request.memberId}
//                     className={classes.notificationItem}
//                     component={Paper}
//                     elevation={1}
//                     sx={{ mb: 2, p: 2 }}
//                   >
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: '#667eea' }}>
//                         <Group />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={`Join request from ${request.userName}`}
//                       secondary={
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             {request.communityName} • {new Date(request.createdAt).toLocaleString()}
//                           </Typography>
//                           <Box mt={1}>
//                             <Button
//                               size="small"
//                               variant="contained"
//                               color="primary"
//                               sx={{ mr: 1 }}
//                               onClick={() => handleApproveMember(request.memberId, request.communityId)}
//                             >
//                               Approve
//                             </Button>
//                             <Button
//                               size="small"
//                               variant="outlined"
//                               color="secondary"
//                               onClick={() => handleRejectMember(request.memberId)}
//                             >
//                               Decline
//                             </Button>
//                           </Box>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}

//           {/* Other Notifications */}
//           <List>
//             {notifications.map((notification) => (
//               <ListItem
//                 key={notification.notificationId}
//                 className={classes.notificationItem}
//                 component={Paper}
//                 elevation={1}
//                 sx={{ mb: 2, p: 2 }}
//               >
//                 <ListItemAvatar>
//                   <Avatar sx={{ bgcolor: '#667eea' }}>
//                     <Notifications />
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={notification.message}
//                   secondary={
//                     <Typography variant="body2" color="text.secondary">
//                       {notification.communityName} • {new Date(notification.createdAt).toLocaleString()}
//                     </Typography>
//                   }
//                 />
//               </ListItem>
//             ))}
//             {notifications.length === 0 && memberRequests.length === 0 && (
//               <Typography variant="body2" color="text.secondary" textAlign="center">
//                 No notifications yet.
//               </Typography>
//             )}
//           </List>
//         </TabPanel>

//         {/* Community Details Dialog with Posts */}
//         <Dialog
//           open={!!selectedCommunity}
//           onClose={() => setSelectedCommunity(null)}
//           maxWidth="md"
//           fullWidth
//           scroll="paper"
//         >
//           {selectedCommunity && (
//             <>
//               <DialogTitle>
//                 <Box display="flex" alignItems="center">
//                   <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                     <Group />
//                   </Avatar>
//                   <Box>
//                     <Typography variant="h6">{selectedCommunity.communityName}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {selectedCommunity.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </DialogTitle>
//               <DialogContent>
//                 <Box display="flex" gap={2} mb={2} flexWrap="wrap">
//                   <Chip label={`${selectedCommunity.members || 1} members`} />
//                   <Chip label={selectedCommunity.type || 'public'} color="primary" />
//                   <Chip label={selectedCommunity.category} variant="outlined" />
//                   {isCommunityOwner(selectedCommunity) && (
//                     <Chip label="You are the owner" color="success" />
//                   )}
//                   {isMember && !isCommunityOwner(selectedCommunity) && (
//                     <Chip label="Member" color="primary" variant="outlined" />
//                   )}
//                 </Box>

//                 {/* Create Post (for members and owner) */}
//                 {(isCommunityOwner(selectedCommunity) || isMember) && (
//                   <Box mb={3}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       placeholder="Share something with the community..."
//                       value={newPost.content}
//                       onChange={(e) => setNewPost({ content: e.target.value })}
//                       multiline
//                       rows={2}
//                     />
//                     <Box mt={1} display="flex" justifyContent="flex-end">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => handleCreatePost(selectedCommunity.communityId)}
//                         disabled={!newPost.content.trim()}
//                       >
//                         Post
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Posts */}
//                 <Typography variant="h6" gutterBottom>
//                   Community Posts
//                 </Typography>
//                 {communityPosts.length > 0 ? (
//                   communityPosts.map((post) => (
//                     <Paper key={post.postId} className={classes.postCard} elevation={1}>
//                       {/* Post Header */}
//                       <Box className={classes.postHeader}>
//                         <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
//                           {post.userName?.charAt(0) || 'U'}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {post.userName}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {new Date(post.createdAt).toLocaleString()}
//                           </Typography>
//                         </Box>
//                       </Box>

//                       {/* Post Content */}
//                       <CardContent>
//                         <Typography variant="body1">
//                           {post.content}
//                         </Typography>
//                       </CardContent>

//                       {/* Action Buttons */}
//                       <Box className={classes.actionButtons}>
//                         <IconButton
//                           onClick={() => handleLikePost(post.postId)}
//                           color={userLikes[post.postId] ? 'error' : 'default'}
//                         >
//                           {userLikes[post.postId] ? <Favorite /> : <FavoriteBorder />}
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.likes || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton onClick={() => fetchPostComments(post.postId)}>
//                           <Comment fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.comments || 0}
//                           </Typography>
//                         </IconButton>
//                         <IconButton>
//                           <Share fontSize="small" />
//                           <Typography variant="body2" sx={{ ml: 1 }}>
//                             {post.shares || 0}
//                           </Typography>
//                         </IconButton>
//                       </Box>

//                       {/* Comments Section */}
//                       {postComments[post.postId] && (
//                         <Box className={classes.commentSection}>
//                           <Typography variant="subtitle2" gutterBottom>
//                             Comments:
//                           </Typography>
//                           {postComments[post.postId].map((commentItem) => (
//                             <Box key={commentItem.commentId} mb={1}>
//                               <Typography variant="body2" fontWeight="bold">
//                                 {commentItem.userName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 {commentItem.content}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {new Date(commentItem.createdAt).toLocaleString()}
//                               </Typography>
//                               <Divider sx={{ mt: 1 }} />
//                             </Box>
//                           ))}

//                           {/* Add Comment */}
//                           <Box mt={2} display="flex">
//                             <TextField
//                               fullWidth
//                               size="small"
//                               placeholder="Write a comment..."
//                               value={comment}
//                               onChange={(e) => setComment(e.target.value)}
//                             />
//                             <IconButton
//                               color="primary"
//                               onClick={() => handleAddComment(post.postId)}
//                               disabled={!comment.trim()}
//                             >
//                               <Send />
//                             </IconButton>
//                           </Box>
//                         </Box>
//                       )}
//                     </Paper>
//                   ))
//                 ) : (
//                   <Typography color="text.secondary" textAlign="center">
//                     No posts yet. Be the first to post!
//                   </Typography>
//                 )}
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setSelectedCommunity(null)}>Close</Button>
//               </DialogActions>
//             </>
//           )}
//         </Dialog>

//         {/* Create Community Dialog */}
//         <Dialog
//           open={createDialogOpen}
//           onClose={() => setCreateDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>Create New Community</DialogTitle>
//           <DialogContent>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Community Name"
//               fullWidth
//               variant="outlined"
//               value={newCommunity.communityName}
//               onChange={(e) => setNewCommunity({ ...newCommunity, communityName: e.target.value })}
//             />
//             <TextField
//               margin="dense"
//               label="Description"
//               fullWidth
//               variant="outlined"
//               multiline
//               rows={3}
//               value={newCommunity.description}
//               onChange={(e) => setNewCommunity({ ...newCommunity, description: e.target.value })}
//             />
//             <TextField
//               margin="dense"
//               label="Category"
//               fullWidth
//               variant="outlined"
//               value={newCommunity.category}
//               onChange={(e) => setNewCommunity({ ...newCommunity, category: e.target.value })}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setCreateDialogOpen(false)}>Cancel</Button>
//             <Button
//               onClick={handleCreateCommunity}
//               variant="contained"
//               color="primary"
//               disabled={!newCommunity.communityName.trim() || loading}
//             >
//               {loading ? 'Creating...' : 'Create Community'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Container>
//     </div>
//   );
// };

// export default Community;
